"use strict";

var _interopRequireDefault2 = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = _interopRequireDefault2(require("@babel/runtime/helpers/typeof"));

(function webpackUniversalModuleDefinition(root, factory) {
  if ((typeof exports === "undefined" ? "undefined" : (0, _typeof3["default"])(exports)) === 'object' && (typeof module === "undefined" ? "undefined" : (0, _typeof3["default"])(module)) === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if ((typeof exports === "undefined" ? "undefined" : (0, _typeof3["default"])(exports)) === 'object') exports["HelloSign"] = factory();else root["HelloSign"] = factory();
})(typeof self !== 'undefined' ? self : void 0, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && (0, _typeof3["default"])(value) === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "./node_modules/common-tags/es/TemplateTag/TemplateTag.js":
      /*!****************************************************************!*\
        !*** ./node_modules/common-tags/es/TemplateTag/TemplateTag.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsTemplateTagTemplateTagJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "./node_modules/core-js/modules/es6.object.freeze.js");

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);

        function _taggedTemplateLiteral(strings, raw) {
          return Object.freeze(Object.defineProperties(strings, {
            raw: {
              value: Object.freeze(raw)
            }
          }));
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }
        /**
         * @class TemplateTag
         * @classdesc Consumes a pipeline of composable transformer plugins and produces a template tag.
         */


        var TemplateTag = function () {
          /**
           * constructs a template tag
           * @constructs TemplateTag
           * @param  {...Object} [...transformers] - an array or arguments list of transformers
           * @return {Function}                    - a template tag
           */
          function TemplateTag() {
            var _this = this;

            for (var _len = arguments.length, transformers = Array(_len), _key = 0; _key < _len; _key++) {
              transformers[_key] = arguments[_key];
            }

            _classCallCheck(this, TemplateTag);

            this.tag = function (strings) {
              for (var _len2 = arguments.length, expressions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                expressions[_key2 - 1] = arguments[_key2];
              }

              if (typeof strings === 'function') {
                // if the first argument passed is a function, assume it is a template tag and return
                // an intermediary tag that processes the template using the aforementioned tag, passing the
                // result to our tag
                return _this.interimTag.bind(_this, strings);
              }

              if (typeof strings === 'string') {
                // if the first argument passed is a string, just transform it
                return _this.transformEndResult(strings);
              } // else, return a transformed end result of processing the template with our tag


              strings = strings.map(_this.transformString.bind(_this));
              return _this.transformEndResult(strings.reduce(_this.processSubstitutions.bind(_this, expressions)));
            }; // if first argument is an array, extrude it as a list of transformers


            if (transformers.length > 0 && Array.isArray(transformers[0])) {
              transformers = transformers[0];
            } // if any transformers are functions, this means they are not initiated - automatically initiate them


            this.transformers = transformers.map(function (transformer) {
              return typeof transformer === 'function' ? transformer() : transformer;
            }); // return an ES2015 template tag

            return this.tag;
          }
          /**
           * Applies all transformers to a template literal tagged with this method.
           * If a function is passed as the first argument, assumes the function is a template tag
           * and applies it to the template, returning a template tag.
           * @param  {(Function|String|Array<String>)} strings        - Either a template tag or an array containing template strings separated by identifier
           * @param  {...*}                            ...expressions - Optional list of substitution values.
           * @return {(String|Function)}                              - Either an intermediary tag function or the results of processing the template.
           */


          _createClass(TemplateTag, [{
            key: 'interimTag',

            /**
             * An intermediary template tag that receives a template tag and passes the result of calling the template with the received
             * template tag to our own template tag.
             * @param  {Function}        nextTag          - the received template tag
             * @param  {Array<String>}   template         - the template to process
             * @param  {...*}            ...substitutions - `substitutions` is an array of all substitutions in the template
             * @return {*}                                - the final processed value
             */
            value: function interimTag(previousTag, template) {
              for (var _len3 = arguments.length, substitutions = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
                substitutions[_key3 - 2] = arguments[_key3];
              }

              return this.tag(_templateObject, previousTag.apply(undefined, [template].concat(substitutions)));
            }
            /**
             * Performs bulk processing on the tagged template, transforming each substitution and then
             * concatenating the resulting values into a string.
             * @param  {Array<*>} substitutions - an array of all remaining substitutions present in this template
             * @param  {String}   resultSoFar   - this iteration's result string so far
             * @param  {String}   remainingPart - the template chunk after the current substitution
             * @return {String}                 - the result of joining this iteration's processed substitution with the result
             */

          }, {
            key: 'processSubstitutions',
            value: function processSubstitutions(substitutions, resultSoFar, remainingPart) {
              var substitution = this.transformSubstitution(substitutions.shift(), resultSoFar);
              return ''.concat(resultSoFar, substitution, remainingPart);
            }
            /**
             * Iterate through each transformer, applying the transformer's `onString` method to the template
             * strings before all substitutions are processed.
             * @param {String}  str - The input string
             * @return {String}     - The final results of processing each transformer
             */

          }, {
            key: 'transformString',
            value: function transformString(str) {
              var cb = function cb(res, transform) {
                return transform.onString ? transform.onString(res) : res;
              };

              return this.transformers.reduce(cb, str);
            }
            /**
             * When a substitution is encountered, iterates through each transformer and applies the transformer's
             * `onSubstitution` method to the substitution.
             * @param  {*}      substitution - The current substitution
             * @param  {String} resultSoFar  - The result up to and excluding this substitution.
             * @return {*}                   - The final result of applying all substitution transformations.
             */

          }, {
            key: 'transformSubstitution',
            value: function transformSubstitution(substitution, resultSoFar) {
              var cb = function cb(res, transform) {
                return transform.onSubstitution ? transform.onSubstitution(res, resultSoFar) : res;
              };

              return this.transformers.reduce(cb, substitution);
            }
            /**
             * Iterates through each transformer, applying the transformer's `onEndResult` method to the
             * template literal after all substitutions have finished processing.
             * @param  {String} endResult - The processed template, just before it is returned from the tag
             * @return {String}           - The final results of processing each transformer
             */

          }, {
            key: 'transformEndResult',
            value: function transformEndResult(endResult) {
              var cb = function cb(res, transform) {
                return transform.onEndResult ? transform.onEndResult(res) : res;
              };

              return this.transformers.reduce(cb, endResult);
            }
          }]);

          return TemplateTag;
        }();

        var _default = TemplateTag;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/TemplateTag/index.js":
      /*!**********************************************************!*\
        !*** ./node_modules/common-tags/es/TemplateTag/index.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsTemplateTagIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _TemplateTag["default"];
          }
        });

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ./TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/TemplateTag.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/codeBlock/index.js":
      /*!********************************************************!*\
        !*** ./node_modules/common-tags/es/codeBlock/index.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCodeBlockIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _html["default"];
          }
        });

        var _html = _interopRequireDefault(__webpack_require__(
        /*! ../html */
        "./node_modules/common-tags/es/html/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/commaLists/commaLists.js":
      /*!**************************************************************!*\
        !*** ./node_modules/common-tags/es/commaLists/commaLists.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCommaListsCommaListsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var commaLists = new _TemplateTag["default"]((0, _inlineArrayTransformer["default"])({
          separator: ','
        }), _stripIndentTransformer["default"], _trimResultTransformer["default"]);
        var _default = commaLists;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/commaLists/index.js":
      /*!*********************************************************!*\
        !*** ./node_modules/common-tags/es/commaLists/index.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCommaListsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _commaLists["default"];
          }
        });

        var _commaLists = _interopRequireDefault(__webpack_require__(
        /*! ./commaLists */
        "./node_modules/common-tags/es/commaLists/commaLists.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/commaListsAnd/commaListsAnd.js":
      /*!********************************************************************!*\
        !*** ./node_modules/common-tags/es/commaListsAnd/commaListsAnd.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCommaListsAndCommaListsAndJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var commaListsAnd = new _TemplateTag["default"]((0, _inlineArrayTransformer["default"])({
          separator: ',',
          conjunction: 'and'
        }), _stripIndentTransformer["default"], _trimResultTransformer["default"]);
        var _default = commaListsAnd;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/commaListsAnd/index.js":
      /*!************************************************************!*\
        !*** ./node_modules/common-tags/es/commaListsAnd/index.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCommaListsAndIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _commaListsAnd["default"];
          }
        });

        var _commaListsAnd = _interopRequireDefault(__webpack_require__(
        /*! ./commaListsAnd */
        "./node_modules/common-tags/es/commaListsAnd/commaListsAnd.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/commaListsOr/commaListsOr.js":
      /*!******************************************************************!*\
        !*** ./node_modules/common-tags/es/commaListsOr/commaListsOr.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCommaListsOrCommaListsOrJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var commaListsOr = new _TemplateTag["default"]((0, _inlineArrayTransformer["default"])({
          separator: ',',
          conjunction: 'or'
        }), _stripIndentTransformer["default"], _trimResultTransformer["default"]);
        var _default = commaListsOr;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/commaListsOr/index.js":
      /*!***********************************************************!*\
        !*** ./node_modules/common-tags/es/commaListsOr/index.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsCommaListsOrIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _commaListsOr["default"];
          }
        });

        var _commaListsOr = _interopRequireDefault(__webpack_require__(
        /*! ./commaListsOr */
        "./node_modules/common-tags/es/commaListsOr/commaListsOr.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/html/html.js":
      /*!**************************************************!*\
        !*** ./node_modules/common-tags/es/html/html.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsHtmlHtmlJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _splitStringTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../splitStringTransformer */
        "./node_modules/common-tags/es/splitStringTransformer/index.js"));

        var _removeNonPrintingValuesTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../removeNonPrintingValuesTransformer */
        "./node_modules/common-tags/es/removeNonPrintingValuesTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var html = new _TemplateTag["default"]((0, _splitStringTransformer["default"])('\n'), _removeNonPrintingValuesTransformer["default"], _inlineArrayTransformer["default"], _stripIndentTransformer["default"], _trimResultTransformer["default"]);
        var _default = html;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/html/index.js":
      /*!***************************************************!*\
        !*** ./node_modules/common-tags/es/html/index.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsHtmlIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _html["default"];
          }
        });

        var _html = _interopRequireDefault(__webpack_require__(
        /*! ./html */
        "./node_modules/common-tags/es/html/html.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/index.js":
      /*!**********************************************!*\
        !*** ./node_modules/common-tags/es/index.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "TemplateTag", {
          enumerable: true,
          get: function get() {
            return _TemplateTag2["default"];
          }
        });
        Object.defineProperty(exports, "trimResultTransformer", {
          enumerable: true,
          get: function get() {
            return _trimResultTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "stripIndentTransformer", {
          enumerable: true,
          get: function get() {
            return _stripIndentTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "replaceResultTransformer", {
          enumerable: true,
          get: function get() {
            return _replaceResultTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "replaceSubstitutionTransformer", {
          enumerable: true,
          get: function get() {
            return _replaceSubstitutionTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "replaceStringTransformer", {
          enumerable: true,
          get: function get() {
            return _replaceStringTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "inlineArrayTransformer", {
          enumerable: true,
          get: function get() {
            return _inlineArrayTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "splitStringTransformer", {
          enumerable: true,
          get: function get() {
            return _splitStringTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "removeNonPrintingValuesTransformer", {
          enumerable: true,
          get: function get() {
            return _removeNonPrintingValuesTransformer2["default"];
          }
        });
        Object.defineProperty(exports, "commaLists", {
          enumerable: true,
          get: function get() {
            return _commaLists2["default"];
          }
        });
        Object.defineProperty(exports, "commaListsAnd", {
          enumerable: true,
          get: function get() {
            return _commaListsAnd2["default"];
          }
        });
        Object.defineProperty(exports, "commaListsOr", {
          enumerable: true,
          get: function get() {
            return _commaListsOr2["default"];
          }
        });
        Object.defineProperty(exports, "html", {
          enumerable: true,
          get: function get() {
            return _html2["default"];
          }
        });
        Object.defineProperty(exports, "codeBlock", {
          enumerable: true,
          get: function get() {
            return _codeBlock2["default"];
          }
        });
        Object.defineProperty(exports, "source", {
          enumerable: true,
          get: function get() {
            return _source2["default"];
          }
        });
        Object.defineProperty(exports, "safeHtml", {
          enumerable: true,
          get: function get() {
            return _safeHtml2["default"];
          }
        });
        Object.defineProperty(exports, "oneLine", {
          enumerable: true,
          get: function get() {
            return _oneLine2["default"];
          }
        });
        Object.defineProperty(exports, "oneLineTrim", {
          enumerable: true,
          get: function get() {
            return _oneLineTrim2["default"];
          }
        });
        Object.defineProperty(exports, "oneLineCommaLists", {
          enumerable: true,
          get: function get() {
            return _oneLineCommaLists2["default"];
          }
        });
        Object.defineProperty(exports, "oneLineCommaListsOr", {
          enumerable: true,
          get: function get() {
            return _oneLineCommaListsOr2["default"];
          }
        });
        Object.defineProperty(exports, "oneLineCommaListsAnd", {
          enumerable: true,
          get: function get() {
            return _oneLineCommaListsAnd2["default"];
          }
        });
        Object.defineProperty(exports, "inlineLists", {
          enumerable: true,
          get: function get() {
            return _inlineLists2["default"];
          }
        });
        Object.defineProperty(exports, "oneLineInlineLists", {
          enumerable: true,
          get: function get() {
            return _oneLineInlineLists2["default"];
          }
        });
        Object.defineProperty(exports, "stripIndent", {
          enumerable: true,
          get: function get() {
            return _stripIndent2["default"];
          }
        });
        Object.defineProperty(exports, "stripIndents", {
          enumerable: true,
          get: function get() {
            return _stripIndents2["default"];
          }
        });

        var _TemplateTag2 = _interopRequireDefault(__webpack_require__(
        /*! ./TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _trimResultTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _stripIndentTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _replaceResultTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        var _replaceSubstitutionTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./replaceSubstitutionTransformer */
        "./node_modules/common-tags/es/replaceSubstitutionTransformer/index.js"));

        var _replaceStringTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./replaceStringTransformer */
        "./node_modules/common-tags/es/replaceStringTransformer/index.js"));

        var _inlineArrayTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _splitStringTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./splitStringTransformer */
        "./node_modules/common-tags/es/splitStringTransformer/index.js"));

        var _removeNonPrintingValuesTransformer2 = _interopRequireDefault(__webpack_require__(
        /*! ./removeNonPrintingValuesTransformer */
        "./node_modules/common-tags/es/removeNonPrintingValuesTransformer/index.js"));

        var _commaLists2 = _interopRequireDefault(__webpack_require__(
        /*! ./commaLists */
        "./node_modules/common-tags/es/commaLists/index.js"));

        var _commaListsAnd2 = _interopRequireDefault(__webpack_require__(
        /*! ./commaListsAnd */
        "./node_modules/common-tags/es/commaListsAnd/index.js"));

        var _commaListsOr2 = _interopRequireDefault(__webpack_require__(
        /*! ./commaListsOr */
        "./node_modules/common-tags/es/commaListsOr/index.js"));

        var _html2 = _interopRequireDefault(__webpack_require__(
        /*! ./html */
        "./node_modules/common-tags/es/html/index.js"));

        var _codeBlock2 = _interopRequireDefault(__webpack_require__(
        /*! ./codeBlock */
        "./node_modules/common-tags/es/codeBlock/index.js"));

        var _source2 = _interopRequireDefault(__webpack_require__(
        /*! ./source */
        "./node_modules/common-tags/es/source/index.js"));

        var _safeHtml2 = _interopRequireDefault(__webpack_require__(
        /*! ./safeHtml */
        "./node_modules/common-tags/es/safeHtml/index.js"));

        var _oneLine2 = _interopRequireDefault(__webpack_require__(
        /*! ./oneLine */
        "./node_modules/common-tags/es/oneLine/index.js"));

        var _oneLineTrim2 = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineTrim */
        "./node_modules/common-tags/es/oneLineTrim/index.js"));

        var _oneLineCommaLists2 = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineCommaLists */
        "./node_modules/common-tags/es/oneLineCommaLists/index.js"));

        var _oneLineCommaListsOr2 = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineCommaListsOr */
        "./node_modules/common-tags/es/oneLineCommaListsOr/index.js"));

        var _oneLineCommaListsAnd2 = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineCommaListsAnd */
        "./node_modules/common-tags/es/oneLineCommaListsAnd/index.js"));

        var _inlineLists2 = _interopRequireDefault(__webpack_require__(
        /*! ./inlineLists */
        "./node_modules/common-tags/es/inlineLists/index.js"));

        var _oneLineInlineLists2 = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineInlineLists */
        "./node_modules/common-tags/es/oneLineInlineLists/index.js"));

        var _stripIndent2 = _interopRequireDefault(__webpack_require__(
        /*! ./stripIndent */
        "./node_modules/common-tags/es/stripIndent/index.js"));

        var _stripIndents2 = _interopRequireDefault(__webpack_require__(
        /*! ./stripIndents */
        "./node_modules/common-tags/es/stripIndents/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/inlineArrayTransformer/index.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/common-tags/es/inlineArrayTransformer/index.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsInlineArrayTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _inlineArrayTransformer["default"];
          }
        });

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/inlineArrayTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/inlineArrayTransformer/inlineArrayTransformer.js":
      /*!**************************************************************************************!*\
        !*** ./node_modules/common-tags/es/inlineArrayTransformer/inlineArrayTransformer.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsInlineArrayTransformerInlineArrayTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.match */
        "./node_modules/core-js/modules/es6.regexp.match.js");

        var defaults = {
          separator: '',
          conjunction: '',
          serial: false
        };
        /**
         * Converts an array substitution to a string containing a list
         * @param  {String} [opts.separator = ''] - the character that separates each item
         * @param  {String} [opts.conjunction = '']  - replace the last separator with this
         * @param  {Boolean} [opts.serial = false] - include the separator before the conjunction? (Oxford comma use-case)
         *
         * @return {Object}                     - a TemplateTag transformer
         */

        var inlineArrayTransformer = function inlineArrayTransformer() {
          var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults;
          return {
            onSubstitution: function onSubstitution(substitution, resultSoFar) {
              // only operate on arrays
              if (Array.isArray(substitution)) {
                var arrayLength = substitution.length;
                var separator = opts.separator;
                var conjunction = opts.conjunction;
                var serial = opts.serial; // join each item in the array into a string where each item is separated by separator
                // be sure to maintain indentation

                var indent = resultSoFar.match(/(\n?[^\S\n]+)$/);

                if (indent) {
                  substitution = substitution.join(separator + indent[1]);
                } else {
                  substitution = substitution.join(separator + ' ');
                } // if conjunction is set, replace the last separator with conjunction, but only if there is more than one substitution


                if (conjunction && arrayLength > 1) {
                  var separatorIndex = substitution.lastIndexOf(separator);
                  substitution = substitution.slice(0, separatorIndex) + (serial ? separator : '') + ' ' + conjunction + substitution.slice(separatorIndex + 1);
                }
              }

              return substitution;
            }
          };
        };

        var _default = inlineArrayTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/inlineLists/index.js":
      /*!**********************************************************!*\
        !*** ./node_modules/common-tags/es/inlineLists/index.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsInlineListsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _inlineLists["default"];
          }
        });

        var _inlineLists = _interopRequireDefault(__webpack_require__(
        /*! ./inlineLists */
        "./node_modules/common-tags/es/inlineLists/inlineLists.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/inlineLists/inlineLists.js":
      /*!****************************************************************!*\
        !*** ./node_modules/common-tags/es/inlineLists/inlineLists.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsInlineListsInlineListsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var inlineLists = new _TemplateTag["default"](_inlineArrayTransformer["default"], _stripIndentTransformer["default"], _trimResultTransformer["default"]);
        var _default = inlineLists;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/oneLine/index.js":
      /*!******************************************************!*\
        !*** ./node_modules/common-tags/es/oneLine/index.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _oneLine["default"];
          }
        });

        var _oneLine = _interopRequireDefault(__webpack_require__(
        /*! ./oneLine */
        "./node_modules/common-tags/es/oneLine/oneLine.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/oneLine/oneLine.js":
      /*!********************************************************!*\
        !*** ./node_modules/common-tags/es/oneLine/oneLine.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineOneLineJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var oneLine = new _TemplateTag["default"]((0, _replaceResultTransformer["default"])(/(?:\n(?:\s*))+/g, ' '), _trimResultTransformer["default"]);
        var _default = oneLine;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/oneLineCommaLists/index.js":
      /*!****************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineCommaLists/index.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineCommaListsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _oneLineCommaLists["default"];
          }
        });

        var _oneLineCommaLists = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineCommaLists */
        "./node_modules/common-tags/es/oneLineCommaLists/oneLineCommaLists.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/oneLineCommaLists/oneLineCommaLists.js":
      /*!****************************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineCommaLists/oneLineCommaLists.js ***!
        \****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineCommaListsOneLineCommaListsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var oneLineCommaLists = new _TemplateTag["default"]((0, _inlineArrayTransformer["default"])({
          separator: ','
        }), (0, _replaceResultTransformer["default"])(/(?:\s+)/g, ' '), _trimResultTransformer["default"]);
        var _default = oneLineCommaLists;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/oneLineCommaListsAnd/index.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineCommaListsAnd/index.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineCommaListsAndIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _oneLineCommaListsAnd["default"];
          }
        });

        var _oneLineCommaListsAnd = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineCommaListsAnd */
        "./node_modules/common-tags/es/oneLineCommaListsAnd/oneLineCommaListsAnd.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/oneLineCommaListsAnd/oneLineCommaListsAnd.js":
      /*!**********************************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineCommaListsAnd/oneLineCommaListsAnd.js ***!
        \**********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineCommaListsAndOneLineCommaListsAndJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var oneLineCommaListsAnd = new _TemplateTag["default"]((0, _inlineArrayTransformer["default"])({
          separator: ',',
          conjunction: 'and'
        }), (0, _replaceResultTransformer["default"])(/(?:\s+)/g, ' '), _trimResultTransformer["default"]);
        var _default = oneLineCommaListsAnd;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/oneLineCommaListsOr/index.js":
      /*!******************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineCommaListsOr/index.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineCommaListsOrIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _oneLineCommaListsOr["default"];
          }
        });

        var _oneLineCommaListsOr = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineCommaListsOr */
        "./node_modules/common-tags/es/oneLineCommaListsOr/oneLineCommaListsOr.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/oneLineCommaListsOr/oneLineCommaListsOr.js":
      /*!********************************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineCommaListsOr/oneLineCommaListsOr.js ***!
        \********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineCommaListsOrOneLineCommaListsOrJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var oneLineCommaListsOr = new _TemplateTag["default"]((0, _inlineArrayTransformer["default"])({
          separator: ',',
          conjunction: 'or'
        }), (0, _replaceResultTransformer["default"])(/(?:\s+)/g, ' '), _trimResultTransformer["default"]);
        var _default = oneLineCommaListsOr;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/oneLineInlineLists/index.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineInlineLists/index.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineInlineListsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _oneLineInlineLists["default"];
          }
        });

        var _oneLineInlineLists = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineInlineLists */
        "./node_modules/common-tags/es/oneLineInlineLists/oneLineInlineLists.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/oneLineInlineLists/oneLineInlineLists.js":
      /*!******************************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineInlineLists/oneLineInlineLists.js ***!
        \******************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineInlineListsOneLineInlineListsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var oneLineInlineLists = new _TemplateTag["default"](_inlineArrayTransformer["default"], (0, _replaceResultTransformer["default"])(/(?:\s+)/g, ' '), _trimResultTransformer["default"]);
        var _default = oneLineInlineLists;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/oneLineTrim/index.js":
      /*!**********************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineTrim/index.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineTrimIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _oneLineTrim["default"];
          }
        });

        var _oneLineTrim = _interopRequireDefault(__webpack_require__(
        /*! ./oneLineTrim */
        "./node_modules/common-tags/es/oneLineTrim/oneLineTrim.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/oneLineTrim/oneLineTrim.js":
      /*!****************************************************************!*\
        !*** ./node_modules/common-tags/es/oneLineTrim/oneLineTrim.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsOneLineTrimOneLineTrimJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var oneLineTrim = new _TemplateTag["default"]((0, _replaceResultTransformer["default"])(/(?:\n\s*)/g, ''), _trimResultTransformer["default"]);
        var _default = oneLineTrim;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/removeNonPrintingValuesTransformer/index.js":
      /*!*********************************************************************************!*\
        !*** ./node_modules/common-tags/es/removeNonPrintingValuesTransformer/index.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsRemoveNonPrintingValuesTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _removeNonPrintingValuesTransformer["default"];
          }
        });

        var _removeNonPrintingValuesTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./removeNonPrintingValuesTransformer */
        "./node_modules/common-tags/es/removeNonPrintingValuesTransformer/removeNonPrintingValuesTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/removeNonPrintingValuesTransformer/removeNonPrintingValuesTransformer.js":
      /*!**************************************************************************************************************!*\
        !*** ./node_modules/common-tags/es/removeNonPrintingValuesTransformer/removeNonPrintingValuesTransformer.js ***!
        \**************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsRemoveNonPrintingValuesTransformerRemoveNonPrintingValuesTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "./node_modules/core-js/modules/es6.number.constructor.js");

        __webpack_require__(
        /*! core-js/modules/es6.number.is-nan */
        "./node_modules/core-js/modules/es6.number.is-nan.js");

        var isValidValue = function isValidValue(x) {
          return x != null && !Number.isNaN(x) && typeof x !== 'boolean';
        };

        var removeNonPrintingValuesTransformer = function removeNonPrintingValuesTransformer() {
          return {
            onSubstitution: function onSubstitution(substitution) {
              if (Array.isArray(substitution)) {
                return substitution.filter(isValidValue);
              }

              if (isValidValue(substitution)) {
                return substitution;
              }

              return '';
            }
          };
        };

        var _default = removeNonPrintingValuesTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/replaceResultTransformer/index.js":
      /*!***********************************************************************!*\
        !*** ./node_modules/common-tags/es/replaceResultTransformer/index.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsReplaceResultTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _replaceResultTransformer["default"];
          }
        });

        var _replaceResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./replaceResultTransformer */
        "./node_modules/common-tags/es/replaceResultTransformer/replaceResultTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/replaceResultTransformer/replaceResultTransformer.js":
      /*!******************************************************************************************!*\
        !*** ./node_modules/common-tags/es/replaceResultTransformer/replaceResultTransformer.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsReplaceResultTransformerReplaceResultTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /**
         * Replaces tabs, newlines and spaces with the chosen value when they occur in sequences
         * @param  {(String|RegExp)} replaceWhat - the value or pattern that should be replaced
         * @param  {*}               replaceWith - the replacement value
         * @return {Object}                      - a TemplateTag transformer
         */


        var replaceResultTransformer = function replaceResultTransformer(replaceWhat, replaceWith) {
          return {
            onEndResult: function onEndResult(endResult) {
              if (replaceWhat == null || replaceWith == null) {
                throw new Error('replaceResultTransformer requires at least 2 arguments.');
              }

              return endResult.replace(replaceWhat, replaceWith);
            }
          };
        };

        var _default = replaceResultTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/replaceStringTransformer/index.js":
      /*!***********************************************************************!*\
        !*** ./node_modules/common-tags/es/replaceStringTransformer/index.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsReplaceStringTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _replaceStringTransformer["default"];
          }
        });

        var _replaceStringTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./replaceStringTransformer */
        "./node_modules/common-tags/es/replaceStringTransformer/replaceStringTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/replaceStringTransformer/replaceStringTransformer.js":
      /*!******************************************************************************************!*\
        !*** ./node_modules/common-tags/es/replaceStringTransformer/replaceStringTransformer.js ***!
        \******************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsReplaceStringTransformerReplaceStringTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");

        var replaceStringTransformer = function replaceStringTransformer(replaceWhat, replaceWith) {
          return {
            onString: function onString(str) {
              if (replaceWhat == null || replaceWith == null) {
                throw new Error('replaceStringTransformer requires at least 2 arguments.');
              }

              return str.replace(replaceWhat, replaceWith);
            }
          };
        };

        var _default = replaceStringTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/replaceSubstitutionTransformer/index.js":
      /*!*****************************************************************************!*\
        !*** ./node_modules/common-tags/es/replaceSubstitutionTransformer/index.js ***!
        \*****************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsReplaceSubstitutionTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _replaceSubstitutionTransformer["default"];
          }
        });

        var _replaceSubstitutionTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./replaceSubstitutionTransformer */
        "./node_modules/common-tags/es/replaceSubstitutionTransformer/replaceSubstitutionTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/replaceSubstitutionTransformer/replaceSubstitutionTransformer.js":
      /*!******************************************************************************************************!*\
        !*** ./node_modules/common-tags/es/replaceSubstitutionTransformer/replaceSubstitutionTransformer.js ***!
        \******************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsReplaceSubstitutionTransformerReplaceSubstitutionTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");

        __webpack_require__(
        /*! core-js/modules/es6.date.to-string */
        "./node_modules/core-js/modules/es6.date.to-string.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");

        var replaceSubstitutionTransformer = function replaceSubstitutionTransformer(replaceWhat, replaceWith) {
          return {
            onSubstitution: function onSubstitution(substitution, resultSoFar) {
              if (replaceWhat == null || replaceWith == null) {
                throw new Error('replaceSubstitutionTransformer requires at least 2 arguments.');
              } // Do not touch if null or undefined


              if (substitution == null) {
                return substitution;
              } else {
                return substitution.toString().replace(replaceWhat, replaceWith);
              }
            }
          };
        };

        var _default = replaceSubstitutionTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/safeHtml/index.js":
      /*!*******************************************************!*\
        !*** ./node_modules/common-tags/es/safeHtml/index.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsSafeHtmlIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _safeHtml["default"];
          }
        });

        var _safeHtml = _interopRequireDefault(__webpack_require__(
        /*! ./safeHtml */
        "./node_modules/common-tags/es/safeHtml/safeHtml.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/safeHtml/safeHtml.js":
      /*!**********************************************************!*\
        !*** ./node_modules/common-tags/es/safeHtml/safeHtml.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsSafeHtmlSafeHtmlJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _inlineArrayTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../inlineArrayTransformer */
        "./node_modules/common-tags/es/inlineArrayTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        var _splitStringTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../splitStringTransformer */
        "./node_modules/common-tags/es/splitStringTransformer/index.js"));

        var _replaceSubstitutionTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../replaceSubstitutionTransformer */
        "./node_modules/common-tags/es/replaceSubstitutionTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var safeHtml = new _TemplateTag["default"]((0, _splitStringTransformer["default"])('\n'), _inlineArrayTransformer["default"], _stripIndentTransformer["default"], _trimResultTransformer["default"], (0, _replaceSubstitutionTransformer["default"])(/&/g, '&amp;'), (0, _replaceSubstitutionTransformer["default"])(/</g, '&lt;'), (0, _replaceSubstitutionTransformer["default"])(/>/g, '&gt;'), (0, _replaceSubstitutionTransformer["default"])(/"/g, '&quot;'), (0, _replaceSubstitutionTransformer["default"])(/'/g, '&#x27;'), (0, _replaceSubstitutionTransformer["default"])(/`/g, '&#x60;'));
        var _default = safeHtml;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/source/index.js":
      /*!*****************************************************!*\
        !*** ./node_modules/common-tags/es/source/index.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsSourceIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _html["default"];
          }
        });

        var _html = _interopRequireDefault(__webpack_require__(
        /*! ../html */
        "./node_modules/common-tags/es/html/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/splitStringTransformer/index.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/common-tags/es/splitStringTransformer/index.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsSplitStringTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _splitStringTransformer["default"];
          }
        });

        var _splitStringTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./splitStringTransformer */
        "./node_modules/common-tags/es/splitStringTransformer/splitStringTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/splitStringTransformer/splitStringTransformer.js":
      /*!**************************************************************************************!*\
        !*** ./node_modules/common-tags/es/splitStringTransformer/splitStringTransformer.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsSplitStringTransformerSplitStringTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "./node_modules/core-js/modules/es6.regexp.split.js");

        __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");

        __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");

        var splitStringTransformer = function splitStringTransformer(splitBy) {
          return {
            onSubstitution: function onSubstitution(substitution, resultSoFar) {
              if (splitBy != null && typeof splitBy === 'string') {
                if (typeof substitution === 'string' && substitution.includes(splitBy)) {
                  substitution = substitution.split(splitBy);
                }
              } else {
                throw new Error('You need to specify a string character to split by.');
              }

              return substitution;
            }
          };
        };

        var _default = splitStringTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/stripIndent/index.js":
      /*!**********************************************************!*\
        !*** ./node_modules/common-tags/es/stripIndent/index.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsStripIndentIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _stripIndent["default"];
          }
        });

        var _stripIndent = _interopRequireDefault(__webpack_require__(
        /*! ./stripIndent */
        "./node_modules/common-tags/es/stripIndent/stripIndent.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/stripIndent/stripIndent.js":
      /*!****************************************************************!*\
        !*** ./node_modules/common-tags/es/stripIndent/stripIndent.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsStripIndentStripIndentJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var stripIndent = new _TemplateTag["default"](_stripIndentTransformer["default"], _trimResultTransformer["default"]);
        var _default = stripIndent;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/stripIndentTransformer/index.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/common-tags/es/stripIndentTransformer/index.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsStripIndentTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _stripIndentTransformer["default"];
          }
        });

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/stripIndentTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/stripIndentTransformer/stripIndentTransformer.js":
      /*!**************************************************************************************!*\
        !*** ./node_modules/common-tags/es/stripIndentTransformer/stripIndentTransformer.js ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsStripIndentTransformerStripIndentTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.constructor */
        "./node_modules/core-js/modules/es6.regexp.constructor.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.match */
        "./node_modules/core-js/modules/es6.regexp.match.js");

        __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "./node_modules/core-js/modules/es6.array.from.js");

        function _toConsumableArray(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          } else {
            return Array.from(arr);
          }
        }
        /**
         * strips indentation from a template literal
         * @param  {String} type = 'initial' - whether to remove all indentation or just leading indentation. can be 'all' or 'initial'
         * @return {Object}                  - a TemplateTag transformer
         */


        var stripIndentTransformer = function stripIndentTransformer() {
          var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'initial';
          return {
            onEndResult: function onEndResult(endResult) {
              if (type === 'initial') {
                // remove the shortest leading indentation from each line
                var match = endResult.match(/^[^\S\n]*(?=\S)/gm);
                var indent = match && Math.min.apply(Math, _toConsumableArray(match.map(function (el) {
                  return el.length;
                })));

                if (indent) {
                  var regexp = new RegExp('^.{' + indent + '}', 'gm');
                  return endResult.replace(regexp, '');
                }

                return endResult;
              }

              if (type === 'all') {
                // remove all indentation from each line
                return endResult.replace(/^[^\S\n]+/gm, '');
              }

              throw new Error('Unknown type: ' + type);
            }
          };
        };

        var _default = stripIndentTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/stripIndents/index.js":
      /*!***********************************************************!*\
        !*** ./node_modules/common-tags/es/stripIndents/index.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsStripIndentsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _stripIndents["default"];
          }
        });

        var _stripIndents = _interopRequireDefault(__webpack_require__(
        /*! ./stripIndents */
        "./node_modules/common-tags/es/stripIndents/stripIndents.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/stripIndents/stripIndents.js":
      /*!******************************************************************!*\
        !*** ./node_modules/common-tags/es/stripIndents/stripIndents.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsStripIndentsStripIndentsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _TemplateTag = _interopRequireDefault(__webpack_require__(
        /*! ../TemplateTag */
        "./node_modules/common-tags/es/TemplateTag/index.js"));

        var _stripIndentTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../stripIndentTransformer */
        "./node_modules/common-tags/es/stripIndentTransformer/index.js"));

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ../trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/index.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var stripIndents = new _TemplateTag["default"]((0, _stripIndentTransformer["default"])('all'), _trimResultTransformer["default"]);
        var _default = stripIndents;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/common-tags/es/trimResultTransformer/index.js":
      /*!********************************************************************!*\
        !*** ./node_modules/common-tags/es/trimResultTransformer/index.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsTrimResultTransformerIndexJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        Object.defineProperty(exports, "default", {
          enumerable: true,
          get: function get() {
            return _trimResultTransformer["default"];
          }
        });

        var _trimResultTransformer = _interopRequireDefault(__webpack_require__(
        /*! ./trimResultTransformer */
        "./node_modules/common-tags/es/trimResultTransformer/trimResultTransformer.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /***/

      },

      /***/
      "./node_modules/common-tags/es/trimResultTransformer/trimResultTransformer.js":
      /*!************************************************************************************!*\
        !*** ./node_modules/common-tags/es/trimResultTransformer/trimResultTransformer.js ***!
        \************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCommonTagsEsTrimResultTransformerTrimResultTransformerJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /**
         * TemplateTag transformer that trims whitespace on the end result of a tagged template
         * @param  {String} side = '' - The side of the string to trim. Can be 'start' or 'end' (alternatively 'left' or 'right')
         * @return {Object}           - a TemplateTag transformer
         */


        var trimResultTransformer = function trimResultTransformer() {
          var side = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          return {
            onEndResult: function onEndResult(endResult) {
              if (side === '') {
                return endResult.trim();
              }

              side = side.toLowerCase();

              if (side === 'start' || side === 'left') {
                return endResult.replace(/^\s*/, '');
              }

              if (side === 'end' || side === 'right') {
                return endResult.replace(/\s*$/, '');
              }

              throw new Error('Side not supported: ' + side);
            }
          };
        };

        var _default = trimResultTransformer;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_a-function.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_a-function.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_add-to-unscopables.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/_add-to-unscopables.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_addToUnscopablesJs(module, exports, __webpack_require__) {
        // 22.1.3.31 Array.prototype[@@unscopables]
        var UNSCOPABLES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('unscopables');

        var ArrayProto = Array.prototype;
        if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});

        module.exports = function (key) {
          ArrayProto[UNSCOPABLES][key] = true;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_advance-string-index.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_advance-string-index.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_advanceStringIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var at = __webpack_require__(
        /*! ./_string-at */
        "./node_modules/core-js/modules/_string-at.js")(true); // `AdvanceStringIndex` abstract operation
        // https://tc39.github.io/ecma262/#sec-advancestringindex


        module.exports = function (S, index, unicode) {
          return index + (unicode ? at(S, index).length : 1);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_an-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_an-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-includes.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_array-includes.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var toAbsoluteIndex = __webpack_require__(
        /*! ./_to-absolute-index */
        "./node_modules/core-js/modules/_to-absolute-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_classof.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_classof.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_classofJs(module, exports, __webpack_require__) {
        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('toStringTag'); // ES3 wrong here


        var ARG = cof(function () {
          return arguments;
        }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (e) {
            /* empty */
          }
        };

        module.exports = function (it) {
          var O, T, B;
          return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
          : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
          : ARG ? cof(O) // ES3 arguments fallback
          : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_cof.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_cof.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_core.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_core.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.6.5'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_create-property.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_create-property.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_createPropertyJs(module, exports, __webpack_require__) {
        "use strict";

        var $defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        module.exports = function (object, index, value) {
          if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_ctx.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_ctx.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_defined.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_defined.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_descriptors.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_descriptors.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_dom-create.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_dom-create.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document; // typeof document.createElement is 'object' in old IE


        var is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_enum-bug-keys.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_enum-keys.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_enum-keys.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_enumKeysJs(module, exports, __webpack_require__) {
        // all enumerable object keys, includes symbols
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "./node_modules/core-js/modules/_object-gops.js");

        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js");

        module.exports = function (it) {
          var result = getKeys(it);
          var getSymbols = gOPS.f;

          if (getSymbols) {
            var symbols = getSymbols(it);
            var isEnum = pIE.f;
            var i = 0;
            var key;

            while (symbols.length > i) {
              if (isEnum.call(it, key = symbols[i++])) result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_export.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_export.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js");

        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
          var key, own, out, exp;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

            out = (own ? target : source)[key]; // bind timers to global for call from export context

            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

            if (target) redefine(target, key, out, type & $export.U); // export

            if (exports[key] != out) hide(exports, key, exp);
            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
          }
        };

        global.core = core; // type bitmap

        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library`

        module.exports = $export;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_fails-is-regexp.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_fails-is-regexp.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_failsIsRegexpJs(module, exports, __webpack_require__) {
        var MATCH = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('match');

        module.exports = function (KEY) {
          var re = /./;

          try {
            '/./'[KEY](re);
          } catch (e) {
            try {
              re[MATCH] = false;
              return !'/./'[KEY](re);
            } catch (f) {
              /* empty */
            }
          }

          return true;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_fails.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_fails.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_fix-re-wks.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_fix-re-wks.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_fixReWksJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! ./es6.regexp.exec */
        "./node_modules/core-js/modules/es6.regexp.exec.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js");

        var regexpExec = __webpack_require__(
        /*! ./_regexp-exec */
        "./node_modules/core-js/modules/_regexp-exec.js");

        var SPECIES = wks('species');
        var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
          // #replace needs built-in support for named groups.
          // #match works fine because it just return the exec results, even if it has
          // a "grops" property.
          var re = /./;

          re.exec = function () {
            var result = [];
            result.groups = {
              a: '7'
            };
            return result;
          };

          return ''.replace(re, '$<a>') !== '7';
        });

        var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
          // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
          var re = /(?:)/;
          var originalExec = re.exec;

          re.exec = function () {
            return originalExec.apply(this, arguments);
          };

          var result = 'ab'.split(re);
          return result.length === 2 && result[0] === 'a' && result[1] === 'b';
        }();

        module.exports = function (KEY, length, exec) {
          var SYMBOL = wks(KEY);
          var DELEGATES_TO_SYMBOL = !fails(function () {
            // String methods call symbol-named RegEp methods
            var O = {};

            O[SYMBOL] = function () {
              return 7;
            };

            return ''[KEY](O) != 7;
          });
          var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
            // Symbol-named RegExp methods call .exec
            var execCalled = false;
            var re = /a/;

            re.exec = function () {
              execCalled = true;
              return null;
            };

            if (KEY === 'split') {
              // RegExp[@@split] doesn't call the regex's exec method, but first creates
              // a new one. We need to return the patched regex when creating the new one.
              re.constructor = {};

              re.constructor[SPECIES] = function () {
                return re;
              };
            }

            re[SYMBOL]('');
            return !execCalled;
          }) : undefined;

          if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
            var nativeRegExpMethod = /./[SYMBOL];
            var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
              if (regexp.exec === regexpExec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                  // The native String method already delegates to @@method (this
                  // polyfilled function), leasing to infinite recursion.
                  // We avoid it by directly calling the native @@method method.
                  return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                  };
                }

                return {
                  done: true,
                  value: nativeMethod.call(str, regexp, arg2)
                };
              }

              return {
                done: false
              };
            });
            var strfn = fns[0];
            var rxfn = fns[1];
            redefine(String.prototype, KEY, strfn);
            hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
            // 21.2.5.11 RegExp.prototype[@@split](string, limit)
            ? function (string, arg) {
              return rxfn.call(string, this, arg);
            } // 21.2.5.6 RegExp.prototype[@@match](string)
            // 21.2.5.9 RegExp.prototype[@@search](string)
            : function (string) {
              return rxfn.call(string, this);
            });
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_flags.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_flags.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_flagsJs(module, exports, __webpack_require__) {
        "use strict"; // 21.2.5.3 get RegExp.prototype.flags

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        module.exports = function () {
          var that = anObject(this);
          var result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_function-to-string.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/_function-to-string.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_functionToStringJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_global.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_global.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_has.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_has.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_hide.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_hide.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_html.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_html.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_htmlJs(module, exports, __webpack_require__) {
        var document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document;

        module.exports = document && document.documentElement;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_ie8-dom-define.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_inherit-if-required.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/_inherit-if-required.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_inheritIfRequiredJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var setPrototypeOf = __webpack_require__(
        /*! ./_set-proto */
        "./node_modules/core-js/modules/_set-proto.js").set;

        module.exports = function (that, target, C) {
          var S = target.constructor;
          var P;

          if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
            setPrototypeOf(that, P);
          }

          return that;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iobject.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_iobject.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js"); // eslint-disable-next-line no-prototype-builtins


        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_is-array-iter.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_is-array-iter.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isArrayIterJs(module, exports, __webpack_require__) {
        // check on default Array iterator
        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator');

        var ArrayProto = Array.prototype;

        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_is-array.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_is-array.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isArrayJs(module, exports, __webpack_require__) {
        // 7.2.2 IsArray(argument)
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js");

        module.exports = Array.isArray || function isArray(arg) {
          return cof(arg) == 'Array';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_is-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_is-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return (0, _typeof3["default"])(it) === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_is-regexp.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_is-regexp.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isRegexpJs(module, exports, __webpack_require__) {
        // 7.2.8 IsRegExp(argument)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js");

        var MATCH = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('match');

        module.exports = function (it) {
          var isRegExp;
          return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-call.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-call.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterCallJs(module, exports, __webpack_require__) {
        // call something on iterator step with safe closing on error
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        module.exports = function (iterator, fn, value, entries) {
          try {
            return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
          } catch (e) {
            var ret = iterator['return'];
            if (ret !== undefined) anObject(ret.call(iterator));
            throw e;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-create.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-create.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterCreateJs(module, exports, __webpack_require__) {
        "use strict";

        var create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js");

        var descriptor = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js");

        var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

        __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
          });
          setToStringTag(Constructor, NAME + ' Iterator');
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-define.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-define.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterDefineJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        var $iterCreate = __webpack_require__(
        /*! ./_iter-create */
        "./node_modules/core-js/modules/_iter-create.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "./node_modules/core-js/modules/_object-gpo.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator');

        var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

        var FF_ITERATOR = '@@iterator';
        var KEYS = 'keys';
        var VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);

          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];

            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };

              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }

            return function entries() {
              return new Constructor(this, kind);
            };
          };

          var TAG = NAME + ' Iterator';
          var DEF_VALUES = DEFAULT == VALUES;
          var VALUES_BUG = false;
          var proto = Base.prototype;
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
          var $default = $native || getMethod(DEFAULT);
          var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
          var methods, key, IteratorPrototype; // Fix native

          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

              if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;

            $default = function values() {
              return $native.call(this);
            };
          } // Define iterator


          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          } // Plug for library


          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;

          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-detect.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-detect.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterDetectJs(module, exports, __webpack_require__) {
        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator');

        var SAFE_CLOSING = false;

        try {
          var riter = [7][ITERATOR]();

          riter['return'] = function () {
            SAFE_CLOSING = true;
          }; // eslint-disable-next-line no-throw-literal


          Array.from(riter, function () {
            throw 2;
          });
        } catch (e) {
          /* empty */
        }

        module.exports = function (exec, skipClosing) {
          if (!skipClosing && !SAFE_CLOSING) return false;
          var safe = false;

          try {
            var arr = [7];
            var iter = arr[ITERATOR]();

            iter.next = function () {
              return {
                done: safe = true
              };
            };

            arr[ITERATOR] = function () {
              return iter;
            };

            exec(arr);
          } catch (e) {
            /* empty */
          }

          return safe;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-step.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-step.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterStepJs(module, exports) {
        module.exports = function (done, value) {
          return {
            value: value,
            done: !!done
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iterators.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iterators.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iteratorsJs(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_library.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_library.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_libraryJs(module, exports) {
        module.exports = false;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_meta.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_meta.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_metaJs(module, exports, __webpack_require__) {
        var META = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js")('meta');

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var setDesc = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        var id = 0;

        var isExtensible = Object.isExtensible || function () {
          return true;
        };

        var FREEZE = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return isExtensible(Object.preventExtensions({}));
        });

        var setMeta = function setMeta(it) {
          setDesc(it, META, {
            value: {
              i: 'O' + ++id,
              // object ID
              w: {} // weak collections IDs

            }
          });
        };

        var fastKey = function fastKey(it, create) {
          // return primitive with prefix
          if (!isObject(it)) return (0, _typeof3["default"])(it) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F'; // not necessary to add metadata

            if (!create) return 'E'; // add missing metadata

            setMeta(it); // return object ID
          }

          return it[META].i;
        };

        var getWeak = function getWeak(it, create) {
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true; // not necessary to add metadata

            if (!create) return false; // add missing metadata

            setMeta(it); // return hash weak collections IDs
          }

          return it[META].w;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function onFreeze(it) {
          if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
          return it;
        };

        var meta = module.exports = {
          KEY: META,
          NEED: false,
          fastKey: fastKey,
          getWeak: getWeak,
          onFreeze: onFreeze
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-create.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-create.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectCreateJs(module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var dPs = __webpack_require__(
        /*! ./_object-dps */
        "./node_modules/core-js/modules/_object-dps.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        var Empty = function Empty() {
          /* empty */
        };

        var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

        var _createDict = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('iframe');

          var i = enumBugKeys.length;
          var lt = '<';
          var gt = '>';
          var iframeDocument;
          iframe.style.display = 'none';

          __webpack_require__(
          /*! ./_html */
          "./node_modules/core-js/modules/_html.js").appendChild(iframe);

          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);

          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict = iframeDocument.F;

          while (i--) {
            delete _createDict[PROTOTYPE][enumBugKeys[i]];
          }

          return _createDict();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _createDict();

          return Properties === undefined ? result : dPs(result, Properties);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-dp.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dp.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/modules/_ie8-dom-define.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js");

        var dP = Object.defineProperty;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-dps.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dps.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpsJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties);
          var length = keys.length;
          var i = 0;
          var P;

          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }

          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gopd.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gopd.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopdJs(module, exports, __webpack_require__) {
        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/modules/_ie8-dom-define.js");

        var gOPD = Object.getOwnPropertyDescriptor;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
          O = toIObject(O);
          P = toPrimitive(P, true);
          if (IE8_DOM_DEFINE) try {
            return gOPD(O, P);
          } catch (e) {
            /* empty */
          }
          if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gopn-ext.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gopn-ext.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopnExtJs(module, exports, __webpack_require__) {
        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "./node_modules/core-js/modules/_object-gopn.js").f;

        var toString = {}.toString;
        var windowNames = (typeof window === "undefined" ? "undefined" : (0, _typeof3["default"])(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

        var getWindowNames = function getWindowNames(it) {
          try {
            return gOPN(it);
          } catch (e) {
            return windowNames.slice();
          }
        };

        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-gopn.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gopn.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopnJs(module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/modules/_object-keys-internal.js");

        var hiddenKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-gops.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gops.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopsJs(module, exports) {
        exports.f = Object.getOwnPropertySymbols;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gpo.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gpo.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGpoJs(module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        var ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectProto : null;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys-internal.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/modules/_array-includes.js")(false);

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/modules/_object-keys-internal.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-pie.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-pie.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectPieJs(module, exports) {
        exports.f = {}.propertyIsEnumerable;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-sap.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-sap.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectSapJs(module, exports, __webpack_require__) {
        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY];
          var exp = {};
          exp[KEY] = exec(fn);
          $export($export.S + $export.F * fails(function () {
            fn(1);
          }), 'Object', exp);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_property-desc.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_property-desc.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_redefine.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_redefine.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_redefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var SRC = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js")('src');

        var $toString = __webpack_require__(
        /*! ./_function-to-string */
        "./node_modules/core-js/modules/_function-to-string.js");

        var TO_STRING = 'toString';
        var TPL = ('' + $toString).split(TO_STRING);

        __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
          return $toString.call(it);
        };

        (module.exports = function (O, key, val, safe) {
          var isFunction = typeof val == 'function';
          if (isFunction) has(val, 'name') || hide(val, 'name', key);
          if (O[key] === val) return;
          if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

          if (O === global) {
            O[key] = val;
          } else if (!safe) {
            delete O[key];
            hide(O, key, val);
          } else if (O[key]) {
            O[key] = val;
          } else {
            hide(O, key, val);
          } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

        })(Function.prototype, TO_STRING, function toString() {
          return typeof this == 'function' && this[SRC] || $toString.call(this);
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_regexp-exec-abstract.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_regexp-exec-abstract.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_regexpExecAbstractJs(module, exports, __webpack_require__) {
        "use strict";

        var classof = __webpack_require__(
        /*! ./_classof */
        "./node_modules/core-js/modules/_classof.js");

        var builtinExec = RegExp.prototype.exec; // `RegExpExec` abstract operation
        // https://tc39.github.io/ecma262/#sec-regexpexec

        module.exports = function (R, S) {
          var exec = R.exec;

          if (typeof exec === 'function') {
            var result = exec.call(R, S);

            if ((0, _typeof3["default"])(result) !== 'object') {
              throw new TypeError('RegExp exec method returned something other than an Object or null');
            }

            return result;
          }

          if (classof(R) !== 'RegExp') {
            throw new TypeError('RegExp#exec called on incompatible receiver');
          }

          return builtinExec.call(R, S);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_regexp-exec.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_regexp-exec.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_regexpExecJs(module, exports, __webpack_require__) {
        "use strict";

        var regexpFlags = __webpack_require__(
        /*! ./_flags */
        "./node_modules/core-js/modules/_flags.js");

        var nativeExec = RegExp.prototype.exec; // This always refers to the native implementation, because the
        // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
        // which loads this file before patching the method.

        var nativeReplace = String.prototype.replace;
        var patchedExec = nativeExec;
        var LAST_INDEX = 'lastIndex';

        var UPDATES_LAST_INDEX_WRONG = function () {
          var re1 = /a/,
              re2 = /b*/g;
          nativeExec.call(re1, 'a');
          nativeExec.call(re2, 'a');
          return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
        }(); // nonparticipating capturing group, copied from es5-shim's String#split patch.


        var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
        var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

        if (PATCH) {
          patchedExec = function exec(str) {
            var re = this;
            var lastIndex, reCopy, match, i;

            if (NPCG_INCLUDED) {
              reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
            }

            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
            match = nativeExec.call(re, str);

            if (UPDATES_LAST_INDEX_WRONG && match) {
              re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
            }

            if (NPCG_INCLUDED && match && match.length > 1) {
              // Fix browsers whose `exec` methods don't consistently return `undefined`
              // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
              // eslint-disable-next-line no-loop-func
              nativeReplace.call(match[0], reCopy, function () {
                for (i = 1; i < arguments.length - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
            }

            return match;
          };
        }

        module.exports = patchedExec;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_same-value.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_same-value.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sameValueJs(module, exports) {
        // 7.2.9 SameValue(x, y)
        module.exports = Object.is || function is(x, y) {
          // eslint-disable-next-line no-self-compare
          return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_set-proto.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_set-proto.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setProtoJs(module, exports, __webpack_require__) {
        // Works with __proto__ only. Old v8 can't work with null proto objects.

        /* eslint-disable no-proto */
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var check = function check(O, proto) {
          anObject(O);
          if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
        };

        module.exports = {
          set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
          function (test, buggy, set) {
            try {
              set = __webpack_require__(
              /*! ./_ctx */
              "./node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__(
              /*! ./_object-gopd */
              "./node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
              set(test, []);
              buggy = !(test instanceof Array);
            } catch (e) {
              buggy = true;
            }

            return function setPrototypeOf(O, proto) {
              check(O, proto);
              if (buggy) O.__proto__ = proto;else set(O, proto);
              return O;
            };
          }({}, false) : undefined),
          check: check
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_set-species.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_set-species.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setSpeciesJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (KEY) {
          var C = global[KEY];
          if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
            configurable: true,
            get: function get() {
              return this;
            }
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_set-to-string-tag.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_set-to-string-tag.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setToStringTagJs(module, exports, __webpack_require__) {
        var def = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
            configurable: true,
            value: tag
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared-key.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_shared-key.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('keys');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_shared.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedJs(module, exports, __webpack_require__) {
        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});
        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: core.version,
          mode: __webpack_require__(
          /*! ./_library */
          "./node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
          copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_species-constructor.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/_species-constructor.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_speciesConstructorJs(module, exports, __webpack_require__) {
        // 7.3.20 SpeciesConstructor(O, defaultConstructor)
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (O, D) {
          var C = anObject(O).constructor;
          var S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-at.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_string-at.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringAtJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js"); // true  -> String#at
        // false -> String#codePointAt


        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that));
            var i = toInteger(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-context.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_string-context.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringContextJs(module, exports, __webpack_require__) {
        // helper for String#{startsWith, endsWith, includes}
        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "./node_modules/core-js/modules/_is-regexp.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (that, searchString, NAME) {
          if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
          return String(defined(that));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-trim.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_string-trim.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringTrimJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        var spaces = __webpack_require__(
        /*! ./_string-ws */
        "./node_modules/core-js/modules/_string-ws.js");

        var space = '[' + spaces + ']';
        var non = "\u200B\x85";
        var ltrim = RegExp('^' + space + space + '*');
        var rtrim = RegExp(space + space + '*$');

        var exporter = function exporter(KEY, exec, ALIAS) {
          var exp = {};
          var FORCE = fails(function () {
            return !!spaces[KEY]() || non[KEY]() != non;
          });
          var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
          if (ALIAS) exp[ALIAS] = fn;
          $export($export.P + $export.F * FORCE, 'String', exp);
        }; // 1 -> String#trimLeft
        // 2 -> String#trimRight
        // 3 -> String#trim


        var trim = exporter.trim = function (string, TYPE) {
          string = String(defined(string));
          if (TYPE & 1) string = string.replace(ltrim, '');
          if (TYPE & 2) string = string.replace(rtrim, '');
          return string;
        };

        module.exports = exporter;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_string-ws.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_string-ws.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringWsJs(module, exports) {
        module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_to-absolute-index.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_to-absolute-index.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toAbsoluteIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var max = Math.max;
        var min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-integer.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-integer.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-iobject.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-iobject.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/modules/_iobject.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-length.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-length.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toObjectJs(module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return Object(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-primitive.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/modules/_to-primitive.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_uid.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_uid.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_uidJs(module, exports) {
        var id = 0;
        var px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_wks-define.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_wks-define.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksDefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js");

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "./node_modules/core-js/modules/_wks-ext.js");

        var defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        module.exports = function (name) {
          var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
          if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
            value: wksExt.f(name)
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_wks-ext.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_wks-ext.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksExtJs(module, exports, __webpack_require__) {
        exports.f = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js");
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_wks.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_wks.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksJs(module, exports, __webpack_require__) {
        var store = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('wks');

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        var _Symbol = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").Symbol;

        var USE_SYMBOL = typeof _Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/core.get-iterator-method.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/modules/core.get-iterator-method.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesCoreGetIteratorMethodJs(module, exports, __webpack_require__) {
        var classof = __webpack_require__(
        /*! ./_classof */
        "./node_modules/core-js/modules/_classof.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator');

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        module.exports = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.array.from.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.from.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayFromJs(module, exports, __webpack_require__) {
        "use strict";

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js");

        var call = __webpack_require__(
        /*! ./_iter-call */
        "./node_modules/core-js/modules/_iter-call.js");

        var isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "./node_modules/core-js/modules/_is-array-iter.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var createProperty = __webpack_require__(
        /*! ./_create-property */
        "./node_modules/core-js/modules/_create-property.js");

        var getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "./node_modules/core-js/modules/core.get-iterator-method.js");

        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_iter-detect */
        "./node_modules/core-js/modules/_iter-detect.js")(function (iter) {
          Array.from(iter);
        }), 'Array', {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(arrayLike
          /* , mapfn = undefined, thisArg = undefined */
          ) {
            var O = toObject(arrayLike);
            var C = typeof this == 'function' ? this : Array;
            var aLen = arguments.length;
            var mapfn = aLen > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            var index = 0;
            var iterFn = getIterFn(O);
            var length, result, step, iterator;
            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
              }
            } else {
              length = toLength(O.length);

              for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
              }
            }

            result.length = index;
            return result;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.array.iterator.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.iterator.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var addToUnscopables = __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js");

        var step = __webpack_require__(
        /*! ./_iter-step */
        "./node_modules/core-js/modules/_iter-step.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"); // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()


        module.exports = __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target

          this._i = 0; // next index

          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;

          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }

          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

        Iterators.Arguments = Iterators.Array;
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.date.to-string.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.date.to-string.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6DateToStringJs(module, exports, __webpack_require__) {
        var DateProto = Date.prototype;
        var INVALID_DATE = 'Invalid Date';
        var TO_STRING = 'toString';
        var $toString = DateProto[TO_STRING];
        var getTime = DateProto.getTime;

        if (new Date(NaN) + '' != INVALID_DATE) {
          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(DateProto, TO_STRING, function toString() {
            var value = getTime.call(this); // eslint-disable-next-line no-self-compare

            return value === value ? $toString.call(this) : INVALID_DATE;
          });
        }
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.function.name.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.function.name.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6FunctionNameJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        var FProto = Function.prototype;
        var nameRE = /^\s*function ([^ (]*)/;
        var NAME = 'name'; // 19.2.4.2 name

        NAME in FProto || __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
          configurable: true,
          get: function get() {
            try {
              return ('' + this).match(nameRE)[1];
            } catch (e) {
              return '';
            }
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.number.constructor.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.number.constructor.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6NumberConstructorJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js");

        var inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "./node_modules/core-js/modules/_inherit-if-required.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "./node_modules/core-js/modules/_object-gopn.js").f;

        var gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "./node_modules/core-js/modules/_object-gopd.js").f;

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        var $trim = __webpack_require__(
        /*! ./_string-trim */
        "./node_modules/core-js/modules/_string-trim.js").trim;

        var NUMBER = 'Number';
        var $Number = global[NUMBER];
        var Base = $Number;
        var proto = $Number.prototype; // Opera ~12 has broken Object#toString

        var BROKEN_COF = cof(__webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js")(proto)) == NUMBER;
        var TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)

        var toNumber = function toNumber(argument) {
          var it = toPrimitive(argument, false);

          if (typeof it == 'string' && it.length > 2) {
            it = TRIM ? it.trim() : $trim(it, 3);
            var first = it.charCodeAt(0);
            var third, radix, maxCode;

            if (first === 43 || first === 45) {
              third = it.charCodeAt(2);
              if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
            } else if (first === 48) {
              switch (it.charCodeAt(1)) {
                case 66:
                case 98:
                  radix = 2;
                  maxCode = 49;
                  break;
                // fast equal /^0b[01]+$/i

                case 79:
                case 111:
                  radix = 8;
                  maxCode = 55;
                  break;
                // fast equal /^0o[0-7]+$/i

                default:
                  return +it;
              }

              for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
                code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols

                if (code < 48 || code > maxCode) return NaN;
              }

              return parseInt(digits, radix);
            }
          }

          return +it;
        };

        if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
          $Number = function Number(value) {
            var it = arguments.length < 1 ? 0 : value;
            var that = this;
            return that instanceof $Number // check on 1..constructor(foo) case
            && (BROKEN_COF ? fails(function () {
              proto.valueOf.call(that);
            }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
          };

          for (var keys = __webpack_require__(
          /*! ./_descriptors */
          "./node_modules/core-js/modules/_descriptors.js") ? gOPN(Base) : ( // ES3:
          'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
          'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
            if (has(Base, key = keys[j]) && !has($Number, key)) {
              dP($Number, key, gOPD(Base, key));
            }
          }

          $Number.prototype = proto;
          proto.constructor = $Number;

          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(global, NUMBER, $Number);
        }
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.number.is-nan.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.number.is-nan.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6NumberIsNanJs(module, exports, __webpack_require__) {
        // 20.1.2.4 Number.isNaN(number)
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        $export($export.S, 'Number', {
          isNaN: function isNaN(number) {
            // eslint-disable-next-line no-self-compare
            return number != number;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.object.freeze.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.object.freeze.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ObjectFreezeJs(module, exports, __webpack_require__) {
        // 19.1.2.5 Object.freeze(O)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var meta = __webpack_require__(
        /*! ./_meta */
        "./node_modules/core-js/modules/_meta.js").onFreeze;

        __webpack_require__(
        /*! ./_object-sap */
        "./node_modules/core-js/modules/_object-sap.js")('freeze', function ($freeze) {
          return function freeze(it) {
            return $freeze && isObject(it) ? $freeze(meta(it)) : it;
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.object.keys.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.object.keys.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ObjectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 Object.keys(O)
        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        __webpack_require__(
        /*! ./_object-sap */
        "./node_modules/core-js/modules/_object-sap.js")('keys', function () {
          return function keys(it) {
            return $keys(toObject(it));
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.object.set-prototype-of.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.object.set-prototype-of.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ObjectSetPrototypeOfJs(module, exports, __webpack_require__) {
        // 19.1.3.19 Object.setPrototypeOf(O, proto)
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        $export($export.S, 'Object', {
          setPrototypeOf: __webpack_require__(
          /*! ./_set-proto */
          "./node_modules/core-js/modules/_set-proto.js").set
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.reflect.get.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.reflect.get.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ReflectGetJs(module, exports, __webpack_require__) {
        // 26.1.6 Reflect.get(target, propertyKey [, receiver])
        var gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "./node_modules/core-js/modules/_object-gopd.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "./node_modules/core-js/modules/_object-gpo.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        function get(target, propertyKey
        /* , receiver */
        ) {
          var receiver = arguments.length < 3 ? target : arguments[2];
          var desc, proto;
          if (anObject(target) === receiver) return target[propertyKey];
          if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
          if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
        }

        $export($export.S, 'Reflect', {
          get: get
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.constructor.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.constructor.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpConstructorJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "./node_modules/core-js/modules/_inherit-if-required.js");

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "./node_modules/core-js/modules/_object-gopn.js").f;

        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "./node_modules/core-js/modules/_is-regexp.js");

        var $flags = __webpack_require__(
        /*! ./_flags */
        "./node_modules/core-js/modules/_flags.js");

        var $RegExp = global.RegExp;
        var Base = $RegExp;
        var proto = $RegExp.prototype;
        var re1 = /a/g;
        var re2 = /a/g; // "new" creates a new object, old webkit buggy here

        var CORRECT_NEW = new $RegExp(re1) !== re1;

        if (__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && (!CORRECT_NEW || __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          re2[__webpack_require__(
          /*! ./_wks */
          "./node_modules/core-js/modules/_wks.js")('match')] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

          return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
        }))) {
          $RegExp = function RegExp(p, f) {
            var tiRE = this instanceof $RegExp;
            var piRE = isRegExp(p);
            var fiU = f === undefined;
            return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
          };

          var proxy = function proxy(key) {
            key in $RegExp || dP($RegExp, key, {
              configurable: true,
              get: function get() {
                return Base[key];
              },
              set: function set(it) {
                Base[key] = it;
              }
            });
          };

          for (var keys = gOPN(Base), i = 0; keys.length > i;) {
            proxy(keys[i++]);
          }

          proto.constructor = $RegExp;
          $RegExp.prototype = proto;

          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(global, 'RegExp', $RegExp);
        }

        __webpack_require__(
        /*! ./_set-species */
        "./node_modules/core-js/modules/_set-species.js")('RegExp');
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.exec.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.exec.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpExecJs(module, exports, __webpack_require__) {
        "use strict";

        var regexpExec = __webpack_require__(
        /*! ./_regexp-exec */
        "./node_modules/core-js/modules/_regexp-exec.js");

        __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js")({
          target: 'RegExp',
          proto: true,
          forced: regexpExec !== /./.exec
        }, {
          exec: regexpExec
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.flags.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.flags.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpFlagsJs(module, exports, __webpack_require__) {
        // 21.2.5.3 get RegExp.prototype.flags()
        if (__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
          configurable: true,
          get: __webpack_require__(
          /*! ./_flags */
          "./node_modules/core-js/modules/_flags.js")
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.match.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.match.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpMatchJs(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var advanceStringIndex = __webpack_require__(
        /*! ./_advance-string-index */
        "./node_modules/core-js/modules/_advance-string-index.js");

        var regExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "./node_modules/core-js/modules/_regexp-exec-abstract.js"); // @@match logic


        __webpack_require__(
        /*! ./_fix-re-wks */
        "./node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
          return [// `String.prototype.match` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.match
          function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
          }, // `RegExp.prototype[@@match]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
          function (regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            if (!rx.global) return regExpExec(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;

            while ((result = regExpExec(rx, S)) !== null) {
              var matchStr = String(result[0]);
              A[n] = matchStr;
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
              n++;
            }

            return n === 0 ? null : A;
          }];
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.replace.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.replace.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpReplaceJs(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js");

        var advanceStringIndex = __webpack_require__(
        /*! ./_advance-string-index */
        "./node_modules/core-js/modules/_advance-string-index.js");

        var regExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "./node_modules/core-js/modules/_regexp-exec-abstract.js");

        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
        var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

        var maybeToString = function maybeToString(it) {
          return it === undefined ? it : String(it);
        }; // @@replace logic


        __webpack_require__(
        /*! ./_fix-re-wks */
        "./node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
          return [// `String.prototype.replace` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.replace
          function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
          }, // `RegExp.prototype[@@replace]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
          function (regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;

            if (global) {
              var fullUnicode = rx.unicode;
              rx.lastIndex = 0;
            }

            var results = [];

            while (true) {
              var result = regExpExec(rx, S);
              if (result === null) break;
              results.push(result);
              if (!global) break;
              var matchStr = String(result[0]);
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }

            var accumulatedResult = '';
            var nextSourcePosition = 0;

            for (var i = 0; i < results.length; i++) {
              result = results[i];
              var matched = String(result[0]);
              var position = max(min(toInteger(result.index), S.length), 0);
              var captures = []; // NOTE: This is equivalent to
              //   captures = result.slice(1).map(maybeToString)
              // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
              // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
              // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

              for (var j = 1; j < result.length; j++) {
                captures.push(maybeToString(result[j]));
              }

              var namedCaptures = result.groups;

              if (functionalReplace) {
                var replacerArgs = [matched].concat(captures, position, S);
                if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                var replacement = String(replaceValue.apply(undefined, replacerArgs));
              } else {
                replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
              }

              if (position >= nextSourcePosition) {
                accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                nextSourcePosition = position + matched.length;
              }
            }

            return accumulatedResult + S.slice(nextSourcePosition);
          }]; // https://tc39.github.io/ecma262/#sec-getsubstitution

          function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

            if (namedCaptures !== undefined) {
              namedCaptures = toObject(namedCaptures);
              symbols = SUBSTITUTION_SYMBOLS;
            }

            return $replace.call(replacement, symbols, function (match, ch) {
              var capture;

              switch (ch.charAt(0)) {
                case '$':
                  return '$';

                case '&':
                  return matched;

                case '`':
                  return str.slice(0, position);

                case "'":
                  return str.slice(tailPos);

                case '<':
                  capture = namedCaptures[ch.slice(1, -1)];
                  break;

                default:
                  // \d\d?
                  var n = +ch;
                  if (n === 0) return match;

                  if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                    return match;
                  }

                  capture = captures[n - 1];
              }

              return capture === undefined ? '' : capture;
            });
          }
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.search.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.search.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpSearchJs(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var sameValue = __webpack_require__(
        /*! ./_same-value */
        "./node_modules/core-js/modules/_same-value.js");

        var regExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "./node_modules/core-js/modules/_regexp-exec-abstract.js"); // @@search logic


        __webpack_require__(
        /*! ./_fix-re-wks */
        "./node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
          return [// `String.prototype.search` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.search
          function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
          }, // `RegExp.prototype[@@search]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
          function (regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = regExpExec(rx, S);
            if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
          }];
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.split.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.split.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpSplitJs(module, exports, __webpack_require__) {
        "use strict";

        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "./node_modules/core-js/modules/_is-regexp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "./node_modules/core-js/modules/_species-constructor.js");

        var advanceStringIndex = __webpack_require__(
        /*! ./_advance-string-index */
        "./node_modules/core-js/modules/_advance-string-index.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js");

        var callRegExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "./node_modules/core-js/modules/_regexp-exec-abstract.js");

        var regexpExec = __webpack_require__(
        /*! ./_regexp-exec */
        "./node_modules/core-js/modules/_regexp-exec.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        var $min = Math.min;
        var $push = [].push;
        var $SPLIT = 'split';
        var LENGTH = 'length';
        var LAST_INDEX = 'lastIndex';
        var MAX_UINT32 = 0xffffffff; // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError

        var SUPPORTS_Y = !fails(function () {
          RegExp(MAX_UINT32, 'y');
        }); // @@split logic

        __webpack_require__(
        /*! ./_fix-re-wks */
        "./node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
          var internalSplit;

          if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
            // based on es5-shim implementation, need to rework it
            internalSplit = function internalSplit(separator, limit) {
              var string = String(this);
              if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

              if (!isRegExp(separator)) return $split.call(string, separator, limit);
              var output = [];
              var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
              var lastLastIndex = 0;
              var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

              var separatorCopy = new RegExp(separator.source, flags + 'g');
              var match, lastIndex, lastLength;

              while (match = regexpExec.call(separatorCopy, string)) {
                lastIndex = separatorCopy[LAST_INDEX];

                if (lastIndex > lastLastIndex) {
                  output.push(string.slice(lastLastIndex, match.index));
                  if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                  lastLength = match[0][LENGTH];
                  lastLastIndex = lastIndex;
                  if (output[LENGTH] >= splitLimit) break;
                }

                if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
              }

              if (lastLastIndex === string[LENGTH]) {
                if (lastLength || !separatorCopy.test('')) output.push('');
              } else output.push(string.slice(lastLastIndex));

              return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
            }; // Chakra, V8

          } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
            internalSplit = function internalSplit(separator, limit) {
              return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
            };
          } else {
            internalSplit = $split;
          }

          return [// `String.prototype.split` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.split
          function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
          }, // `RegExp.prototype[@@split]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
          //
          // NOTE: This cannot be properly polyfilled in engines that don't support
          // the 'y' flag.
          function (regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var C = speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g'); // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.

            var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
            var p = 0;
            var q = 0;
            var A = [];

            while (q < S.length) {
              splitter.lastIndex = SUPPORTS_Y ? q : 0;
              var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
              var e;

              if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
                q = advanceStringIndex(S, q, unicodeMatching);
              } else {
                A.push(S.slice(p, q));
                if (A.length === lim) return A;

                for (var i = 1; i <= z.length - 1; i++) {
                  A.push(z[i]);
                  if (A.length === lim) return A;
                }

                q = p = e;
              }
            }

            A.push(S.slice(p));
            return A;
          }];
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.to-string.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.to-string.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpToStringJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! ./es6.regexp.flags */
        "./node_modules/core-js/modules/es6.regexp.flags.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var $flags = __webpack_require__(
        /*! ./_flags */
        "./node_modules/core-js/modules/_flags.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js");

        var TO_STRING = 'toString';
        var $toString = /./[TO_STRING];

        var define = function define(fn) {
          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
        }; // 21.2.5.14 RegExp.prototype.toString()


        if (__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return $toString.call({
            source: 'a',
            flags: 'b'
          }) != '/a/b';
        })) {
          define(function toString() {
            var R = anObject(this);
            return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
          }); // FF44- RegExp#toString has a wrong name
        } else if ($toString.name != TO_STRING) {
          define(function toString() {
            return $toString.call(this);
          });
        }
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.string.includes.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.string.includes.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6StringIncludesJs(module, exports, __webpack_require__) {
        "use strict"; // 21.1.3.7 String.prototype.includes(searchString, position = 0)

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var context = __webpack_require__(
        /*! ./_string-context */
        "./node_modules/core-js/modules/_string-context.js");

        var INCLUDES = 'includes';
        $export($export.P + $export.F * __webpack_require__(
        /*! ./_fails-is-regexp */
        "./node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
          includes: function includes(searchString
          /* , position = 0 */
          ) {
            return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.string.iterator.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.string.iterator.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6StringIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var $at = __webpack_require__(
        /*! ./_string-at */
        "./node_modules/core-js/modules/_string-at.js")(true); // 21.1.3.27 String.prototype[@@iterator]()


        __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/modules/_iter-define.js")(String, 'String', function (iterated) {
          this._t = String(iterated); // target

          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return {
            value: undefined,
            done: true
          };
          point = $at(O, index);
          this._i += point.length;
          return {
            value: point,
            done: false
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.symbol.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/es6.symbol.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6SymbolJs(module, exports, __webpack_require__) {
        "use strict"; // ECMAScript 6 symbols shim

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var META = __webpack_require__(
        /*! ./_meta */
        "./node_modules/core-js/modules/_meta.js").KEY;

        var $fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js");

        var uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "./node_modules/core-js/modules/_wks-ext.js");

        var wksDefine = __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/modules/_wks-define.js");

        var enumKeys = __webpack_require__(
        /*! ./_enum-keys */
        "./node_modules/core-js/modules/_enum-keys.js");

        var isArray = __webpack_require__(
        /*! ./_is-array */
        "./node_modules/core-js/modules/_is-array.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        var _create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js");

        var gOPNExt = __webpack_require__(
        /*! ./_object-gopn-ext */
        "./node_modules/core-js/modules/_object-gopn-ext.js");

        var $GOPD = __webpack_require__(
        /*! ./_object-gopd */
        "./node_modules/core-js/modules/_object-gopd.js");

        var $DP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        var gOPD = $GOPD.f;
        var dP = $DP.f;
        var gOPN = gOPNExt.f;
        var $Symbol = global.Symbol;
        var $JSON = global.JSON;

        var _stringify = $JSON && $JSON.stringify;

        var PROTOTYPE = 'prototype';
        var HIDDEN = wks('_hidden');
        var TO_PRIMITIVE = wks('toPrimitive');
        var isEnum = {}.propertyIsEnumerable;
        var SymbolRegistry = shared('symbol-registry');
        var AllSymbols = shared('symbols');
        var OPSymbols = shared('op-symbols');
        var ObjectProto = Object[PROTOTYPE];
        var USE_NATIVE = typeof $Symbol == 'function';
        var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

        var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

        var setSymbolDesc = DESCRIPTORS && $fails(function () {
          return _create(dP({}, 'a', {
            get: function get() {
              return dP(this, 'a', {
                value: 7
              }).a;
            }
          })).a != 7;
        }) ? function (it, key, D) {
          var protoDesc = gOPD(ObjectProto, key);
          if (protoDesc) delete ObjectProto[key];
          dP(it, key, D);
          if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
        } : dP;

        var wrap = function wrap(tag) {
          var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

          sym._k = tag;
          return sym;
        };

        var isSymbol = USE_NATIVE && (0, _typeof3["default"])($Symbol.iterator) == 'symbol' ? function (it) {
          return (0, _typeof3["default"])(it) == 'symbol';
        } : function (it) {
          return it instanceof $Symbol;
        };

        var $defineProperty = function defineProperty(it, key, D) {
          if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
          anObject(it);
          key = toPrimitive(key, true);
          anObject(D);

          if (has(AllSymbols, key)) {
            if (!D.enumerable) {
              if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
              it[HIDDEN][key] = true;
            } else {
              if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
              D = _create(D, {
                enumerable: createDesc(0, false)
              });
            }

            return setSymbolDesc(it, key, D);
          }

          return dP(it, key, D);
        };

        var $defineProperties = function defineProperties(it, P) {
          anObject(it);
          var keys = enumKeys(P = toIObject(P));
          var i = 0;
          var l = keys.length;
          var key;

          while (l > i) {
            $defineProperty(it, key = keys[i++], P[key]);
          }

          return it;
        };

        var $create = function create(it, P) {
          return P === undefined ? _create(it) : $defineProperties(_create(it), P);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(key) {
          var E = isEnum.call(this, key = toPrimitive(key, true));
          if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
          return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
        };

        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
          it = toIObject(it);
          key = toPrimitive(key, true);
          if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
          var D = gOPD(it, key);
          if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
          return D;
        };

        var $getOwnPropertyNames = function getOwnPropertyNames(it) {
          var names = gOPN(toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
          }

          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
          var IS_OP = it === ObjectProto;
          var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
          }

          return result;
        }; // 19.4.1.1 Symbol([description])


        if (!USE_NATIVE) {
          $Symbol = function _Symbol2() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

            var $set = function $set(value) {
              if (this === ObjectProto) $set.call(OPSymbols, value);
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDesc(this, tag, createDesc(1, value));
            };

            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
              configurable: true,
              set: $set
            });
            return wrap(tag);
          };

          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return this._k;
          });
          $GOPD.f = $getOwnPropertyDescriptor;
          $DP.f = $defineProperty;
          __webpack_require__(
          /*! ./_object-gopn */
          "./node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
          __webpack_require__(
          /*! ./_object-pie */
          "./node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
          __webpack_require__(
          /*! ./_object-gops */
          "./node_modules/core-js/modules/_object-gops.js").f = $getOwnPropertySymbols;

          if (DESCRIPTORS && !__webpack_require__(
          /*! ./_library */
          "./node_modules/core-js/modules/_library.js")) {
            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
          }

          wksExt.f = function (name) {
            return wrap(wks(name));
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Symbol: $Symbol
        });

        for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
          wks(es6Symbols[j++]);
        }

        for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
          wksDefine(wellKnownSymbols[k++]);
        }

        $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
          // 19.4.2.1 Symbol.for(key)
          'for': function _for(key) {
            return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
          },
          // 19.4.2.5 Symbol.keyFor(sym)
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

            for (var key in SymbolRegistry) {
              if (SymbolRegistry[key] === sym) return key;
            }
          },
          useSetter: function useSetter() {
            setter = true;
          },
          useSimple: function useSimple() {
            setter = false;
          }
        });
        $export($export.S + $export.F * !USE_NATIVE, 'Object', {
          // 19.1.2.2 Object.create(O [, Properties])
          create: $create,
          // 19.1.2.4 Object.defineProperty(O, P, Attributes)
          defineProperty: $defineProperty,
          // 19.1.2.3 Object.defineProperties(O, Properties)
          defineProperties: $defineProperties,
          // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
          // 19.1.2.7 Object.getOwnPropertyNames(O)
          getOwnPropertyNames: $getOwnPropertyNames,
          // 19.1.2.8 Object.getOwnPropertySymbols(O)
          getOwnPropertySymbols: $getOwnPropertySymbols
        }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

        $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
          var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
          // WebKit converts symbol values to JSON as null
          // V8 throws on boxed symbols

          return _stringify([S]) != '[null]' || _stringify({
            a: S
          }) != '{}' || _stringify(Object(S)) != '{}';
        })), 'JSON', {
          stringify: function stringify(it) {
            var args = [it];
            var i = 1;
            var replacer, $replacer;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            $replacer = replacer = args[1];
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

            if (!isArray(replacer)) replacer = function replacer(key, value) {
              if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
              if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return _stringify.apply($JSON, args);
          }
        }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

        $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

        setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

        setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

        setToStringTag(global.JSON, 'JSON', true);
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es7.array.includes.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.array.includes.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7ArrayIncludesJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/Array.prototype.includes

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        var $includes = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/modules/_array-includes.js")(true);

        $export($export.P, 'Array', {
          includes: function includes(el
          /* , fromIndex = 0 */
          ) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js")('includes');
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es7.symbol.async-iterator.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.symbol.async-iterator.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7SymbolAsyncIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/modules/_wks-define.js")('asyncIterator');
        /***/

      },

      /***/
      "./node_modules/core-js/modules/web.dom.iterable.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/web.dom.iterable.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesWebDomIterableJs(module, exports, __webpack_require__) {
        var $iterators = __webpack_require__(
        /*! ./es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js");

        var ITERATOR = wks('iterator');
        var TO_STRING_TAG = wks('toStringTag');
        var ArrayValues = Iterators.Array;
        var DOMIterables = {
          CSSRuleList: true,
          // TODO: Not spec compliant, should be false.
          CSSStyleDeclaration: false,
          CSSValueList: false,
          ClientRectList: false,
          DOMRectList: false,
          DOMStringList: false,
          DOMTokenList: true,
          DataTransferItemList: false,
          FileList: false,
          HTMLAllCollection: false,
          HTMLCollection: false,
          HTMLFormElement: false,
          HTMLSelectElement: false,
          MediaList: true,
          // TODO: Not spec compliant, should be false.
          MimeTypeArray: false,
          NamedNodeMap: false,
          NodeList: true,
          PaintRequestList: false,
          Plugin: false,
          PluginArray: false,
          SVGLengthList: false,
          SVGNumberList: false,
          SVGPathSegList: false,
          SVGPointList: false,
          SVGStringList: false,
          SVGTransformList: false,
          SourceBufferList: false,
          StyleSheetList: true,
          // TODO: Not spec compliant, should be false.
          TextTrackCueList: false,
          TextTrackList: false,
          TouchList: false
        };

        for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
          var NAME = collections[i];
          var explicit = DOMIterables[NAME];
          var Collection = global[NAME];
          var proto = Collection && Collection.prototype;
          var key;

          if (proto) {
            if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
            if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
            Iterators[NAME] = ArrayValues;
            if (explicit) for (key in $iterators) {
              if (!proto[key]) redefine(proto, key, $iterators[key], true);
            }
          }
        }
        /***/

      },

      /***/
      "./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/lib/loader.js!./src/sass/embedded.scss":
      /*!***************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/lib/loader.js!./src/sass/embedded.scss ***!
        \***************************************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistCjsJsNode_modulesSassLoaderLibLoaderJsSrcSassEmbeddedScss(module, exports, __webpack_require__) {
        exports = module.exports = __webpack_require__(
        /*! ../../node_modules/css-loader/dist/runtime/api.js */
        "./node_modules/css-loader/dist/runtime/api.js")(false); // Module

        exports.push([module.i, ".x-hellosign-embedded {\n  height: 100%; }\n  .x-hellosign-embedded--in-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 9997; }\n\n.x-hellosign-embedded__modal-screen {\n  display: block;\n  background-color: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n  @media only screen and (max-width: 767px), only screen and (max-width: 900px) and (min-aspect-ratio: 16 / 9) {\n    .x-hellosign-embedded__modal-screen {\n      display: none; } }\n\n.x-hellosign-embedded__modal-content {\n  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.25);\n  position: absolute;\n  top: 5vh;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 90vh;\n  min-height: 400px;\n  width: 80vw;\n  min-width: 512px;\n  max-width: 1024px; }\n  @media only screen and (max-width: 767px), only screen and (max-width: 900px) and (min-aspect-ratio: 16 / 9) {\n    .x-hellosign-embedded__modal-content {\n      overflow: hidden;\n      box-shadow: none;\n      height: 100%;\n      min-height: 0;\n      width: 100%;\n      min-width: 0;\n      transform: none;\n      left: 0;\n      top: 0; } }\n\n.x-hellosign-embedded__modal-close {\n  position: absolute;\n  top: 0;\n  right: -60px;\n  height: 40px;\n  width: 40px; }\n  @media only screen and (max-width: 767px), only screen and (max-width: 900px) and (min-aspect-ratio: 16 / 9) {\n    .x-hellosign-embedded__modal-close {\n      display: none; } }\n\n.x-hellosign-embedded__modal-close-button {\n  -webkit-appearance: none;\n  height: 100%;\n  width: 100%;\n  border: none;\n  background-color: #1A1A1A;\n  transition: background-color 0.35s ease;\n  will-change: background-color;\n  box-shadow: 0px 3px 9px 0px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  padding: 20px; }\n  .x-hellosign-embedded__modal-close-button:hover {\n    background-color: #4E4E4E; }\n  .x-hellosign-embedded__modal-close-button::before, .x-hellosign-embedded__modal-close-button::after {\n    content: '';\n    position: absolute;\n    width: 1px;\n    background-color: white;\n    height: 20px;\n    top: 10px; }\n  .x-hellosign-embedded__modal-close-button::before {\n    transform: rotateZ(45deg); }\n  .x-hellosign-embedded__modal-close-button::after {\n    transform: rotateZ(-45deg); }\n\n.x-hellosign-embedded__iframe {\n  min-height: 400px;\n  background-color: #F7F8F9;\n  height: 100%;\n  border: none;\n  min-width: 100%;\n  width: 100px;\n  *width: 100%; }\n", ""]);
        /***/
      },

      /***/
      "./node_modules/css-loader/dist/runtime/api.js":
      /*!*****************************************************!*\
        !*** ./node_modules/css-loader/dist/runtime/api.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCssLoaderDistRuntimeApiJs(module, exports, __webpack_require__) {
        "use strict";
        /*
          MIT License http://www.opensource.org/licenses/mit-license.php
          Author Tobias Koppers @sokra
        */
        // css base code, injected by the css-loader

        module.exports = function (useSourceMap) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function (item) {
              var content = cssWithMappingToString(item, useSourceMap);

              if (item[2]) {
                return '@media ' + item[2] + '{' + content + '}';
              } else {
                return content;
              }
            }).join('');
          }; // import a list of modules into the list


          list.i = function (modules, mediaQuery) {
            if (typeof modules === 'string') {
              modules = [[null, modules, '']];
            }

            var alreadyImportedModules = {};

            for (var i = 0; i < this.length; i++) {
              var id = this[i][0];

              if (id != null) {
                alreadyImportedModules[id] = true;
              }
            }

            for (i = 0; i < modules.length; i++) {
              var item = modules[i]; // skip already imported module
              // this implementation is not 100% perfect for weird media query combinations
              // when a module is imported multiple times with different media queries.
              // I hope this will never occur (Hey this way we have smaller bundles)

              if (item[0] == null || !alreadyImportedModules[item[0]]) {
                if (mediaQuery && !item[2]) {
                  item[2] = mediaQuery;
                } else if (mediaQuery) {
                  item[2] = '(' + item[2] + ') and (' + mediaQuery + ')';
                }

                list.push(item);
              }
            }
          };

          return list;
        };

        function cssWithMappingToString(item, useSourceMap) {
          var content = item[1] || '';
          var cssMapping = item[3];

          if (!cssMapping) {
            return content;
          }

          if (useSourceMap && typeof btoa === 'function') {
            var sourceMapping = toComment(cssMapping);
            var sourceURLs = cssMapping.sources.map(function (source) {
              return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
            });
            return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
          }

          return [content].join('\n');
        } // Adapted from convert-source-map (MIT)


        function toComment(sourceMap) {
          // eslint-disable-next-line no-undef
          var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
          var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
          return '/*# ' + data + ' */';
        }
        /***/

      },

      /***/
      "./node_modules/debug/node_modules/ms/index.js":
      /*!*****************************************************!*\
        !*** ./node_modules/debug/node_modules/ms/index.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesDebugNode_modulesMsIndexJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");

        function _typeof(obj) {
          if (typeof Symbol === "function" && (0, _typeof3["default"])(Symbol.iterator) === "symbol") {
            _typeof = function _typeof(obj) {
              return (0, _typeof3["default"])(obj);
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3["default"])(obj);
            };
          }

          return _typeof(obj);
        }
        /**
         * Helpers.
         */


        var s = 1000;
        var m = s * 60;
        var h = m * 60;
        var d = h * 24;
        var w = d * 7;
        var y = d * 365.25;
        /**
         * Parse or format the given `val`.
         *
         * Options:
         *
         *  - `long` verbose formatting [false]
         *
         * @param {String|Number} val
         * @param {Object} [options]
         * @throws {Error} throw an error if val is not a non-empty string or a number
         * @return {String|Number}
         * @api public
         */

        module.exports = function (val, options) {
          options = options || {};

          var type = _typeof(val);

          if (type === 'string' && val.length > 0) {
            return parse(val);
          } else if (type === 'number' && isNaN(val) === false) {
            return options["long"] ? fmtLong(val) : fmtShort(val);
          }

          throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
        };
        /**
         * Parse the given `str` and return milliseconds.
         *
         * @param {String} str
         * @return {Number}
         * @api private
         */


        function parse(str) {
          str = String(str);

          if (str.length > 100) {
            return;
          }

          var match = /^((?:\d+)?\-?\d?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

          if (!match) {
            return;
          }

          var n = parseFloat(match[1]);
          var type = (match[2] || 'ms').toLowerCase();

          switch (type) {
            case 'years':
            case 'year':
            case 'yrs':
            case 'yr':
            case 'y':
              return n * y;

            case 'weeks':
            case 'week':
            case 'w':
              return n * w;

            case 'days':
            case 'day':
            case 'd':
              return n * d;

            case 'hours':
            case 'hour':
            case 'hrs':
            case 'hr':
            case 'h':
              return n * h;

            case 'minutes':
            case 'minute':
            case 'mins':
            case 'min':
            case 'm':
              return n * m;

            case 'seconds':
            case 'second':
            case 'secs':
            case 'sec':
            case 's':
              return n * s;

            case 'milliseconds':
            case 'millisecond':
            case 'msecs':
            case 'msec':
            case 'ms':
              return n;

            default:
              return undefined;
          }
        }
        /**
         * Short format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */


        function fmtShort(ms) {
          var msAbs = Math.abs(ms);

          if (msAbs >= d) {
            return Math.round(ms / d) + 'd';
          }

          if (msAbs >= h) {
            return Math.round(ms / h) + 'h';
          }

          if (msAbs >= m) {
            return Math.round(ms / m) + 'm';
          }

          if (msAbs >= s) {
            return Math.round(ms / s) + 's';
          }

          return ms + 'ms';
        }
        /**
         * Long format for `ms`.
         *
         * @param {Number} ms
         * @return {String}
         * @api private
         */


        function fmtLong(ms) {
          var msAbs = Math.abs(ms);

          if (msAbs >= d) {
            return plural(ms, msAbs, d, 'day');
          }

          if (msAbs >= h) {
            return plural(ms, msAbs, h, 'hour');
          }

          if (msAbs >= m) {
            return plural(ms, msAbs, m, 'minute');
          }

          if (msAbs >= s) {
            return plural(ms, msAbs, s, 'second');
          }

          return ms + ' ms';
        }
        /**
         * Pluralization helper.
         */


        function plural(ms, msAbs, n, name) {
          var isPlural = msAbs >= n * 1.5;
          return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
        }
        /***/

      },

      /***/
      "./node_modules/debug/src/browser.js":
      /*!*******************************************!*\
        !*** ./node_modules/debug/src/browser.js ***!
        \*******************************************/

      /*! no static exports found */

      /***/
      function node_modulesDebugSrcBrowserJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (process) {
          __webpack_require__(
          /*! core-js/modules/es7.symbol.async-iterator */
          "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

          __webpack_require__(
          /*! core-js/modules/es6.symbol */
          "./node_modules/core-js/modules/es6.symbol.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.replace */
          "./node_modules/core-js/modules/es6.regexp.replace.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.constructor */
          "./node_modules/core-js/modules/es6.regexp.constructor.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.match */
          "./node_modules/core-js/modules/es6.regexp.match.js");

          function _typeof(obj) {
            if (typeof Symbol === "function" && (0, _typeof3["default"])(Symbol.iterator) === "symbol") {
              _typeof = function _typeof(obj) {
                return (0, _typeof3["default"])(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3["default"])(obj);
              };
            }

            return _typeof(obj);
          }
          /* eslint-env browser */

          /**
           * This is the web browser implementation of `debug()`.
           */


          exports.log = log;
          exports.formatArgs = formatArgs;
          exports.save = save;
          exports.load = load;
          exports.useColors = useColors;
          exports.storage = localstorage();
          /**
           * Colors.
           */

          exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
          /**
           * Currently only WebKit-based Web Inspectors, Firefox >= v31,
           * and the Firebug extension (any Firefox version) are known
           * to support "%c" CSS customizations.
           *
           * TODO: add a `localStorage` variable to explicitly enable/disable colors
           */
          // eslint-disable-next-line complexity

          function useColors() {
            // NB: In an Electron preload script, document will be defined but not fully
            // initialized. Since we know we're in Chrome, we'll just detect this case
            // explicitly
            if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
              return true;
            } // Internet Explorer and Edge do not support colors.


            if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
              return false;
            } // Is webkit? http://stackoverflow.com/a/16459606/376773
            // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


            return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
            typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
            // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
            typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
            typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
          }
          /**
           * Colorize log arguments if enabled.
           *
           * @api public
           */


          function formatArgs(args) {
            args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

            if (!this.useColors) {
              return;
            }

            var c = 'color: ' + this.color;
            args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
            // arguments passed either before or after the %c, so we need to
            // figure out the correct index to insert the CSS into

            var index = 0;
            var lastC = 0;
            args[0].replace(/%[a-zA-Z%]/g, function (match) {
              if (match === '%%') {
                return;
              }

              index++;

              if (match === '%c') {
                // We only are interested in the *last* %c
                // (the user may have provided their own)
                lastC = index;
              }
            });
            args.splice(lastC, 0, c);
          }
          /**
           * Invokes `console.log()` when available.
           * No-op when `console.log` is not a "function".
           *
           * @api public
           */


          function log() {
            var _console; // This hackery is required for IE8/9, where
            // the `console.log` function doesn't have 'apply'


            return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
          }
          /**
           * Save `namespaces`.
           *
           * @param {String} namespaces
           * @api private
           */


          function save(namespaces) {
            try {
              if (namespaces) {
                exports.storage.setItem('debug', namespaces);
              } else {
                exports.storage.removeItem('debug');
              }
            } catch (error) {// Swallow
              // XXX (@Qix-) should we be logging these?
            }
          }
          /**
           * Load `namespaces`.
           *
           * @return {String} returns the previously persisted debug modes
           * @api private
           */


          function load() {
            var r;

            try {
              r = exports.storage.getItem('debug');
            } catch (error) {} // Swallow
            // XXX (@Qix-) should we be logging these?
            // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


            if (!r && typeof process !== 'undefined' && 'env' in process) {
              r = process.env.DEBUG;
            }

            return r;
          }
          /**
           * Localstorage attempts to return the localstorage.
           *
           * This is necessary because safari throws
           * when a user disables cookies/localstorage
           * and you attempt to access it.
           *
           * @return {LocalStorage}
           * @api private
           */


          function localstorage() {
            try {
              // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
              // The Browser also has localStorage in the global context.
              return localStorage;
            } catch (error) {// Swallow
              // XXX (@Qix-) should we be logging these?
            }
          }

          module.exports = __webpack_require__(
          /*! ./common */
          "./node_modules/debug/src/common.js")(exports);
          var formatters = module.exports.formatters;
          /**
           * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
           */

          formatters.j = function (v) {
            try {
              return JSON.stringify(v);
            } catch (error) {
              return '[UnexpectedJSONParseError]: ' + error.message;
            }
          };
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../../process/browser.js */
        "./node_modules/process/browser.js"));
        /***/
      },

      /***/
      "./node_modules/debug/src/common.js":
      /*!******************************************!*\
        !*** ./node_modules/debug/src/common.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesDebugSrcCommonJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "./node_modules/core-js/modules/es6.array.from.js");

        __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");

        __webpack_require__(
        /*! core-js/modules/es6.date.to-string */
        "./node_modules/core-js/modules/es6.date.to-string.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.constructor */
        "./node_modules/core-js/modules/es6.regexp.constructor.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "./node_modules/core-js/modules/es6.regexp.split.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");

        __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "./node_modules/core-js/modules/es6.number.constructor.js");

        __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");

        __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");

        function _toConsumableArray(arr) {
          return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
        }

        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }

        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }

        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }
        }
        /**
         * This is the common logic for both the Node.js and web browser
         * implementations of `debug()`.
         */


        function setup(env) {
          createDebug.debug = createDebug;
          createDebug["default"] = createDebug;
          createDebug.coerce = coerce;
          createDebug.disable = disable;
          createDebug.enable = enable;
          createDebug.enabled = enabled;
          createDebug.humanize = __webpack_require__(
          /*! ms */
          "./node_modules/debug/node_modules/ms/index.js");
          Object.keys(env).forEach(function (key) {
            createDebug[key] = env[key];
          });
          /**
          * Active `debug` instances.
          */

          createDebug.instances = [];
          /**
          * The currently active debug mode names, and names to skip.
          */

          createDebug.names = [];
          createDebug.skips = [];
          /**
          * Map of special "%n" handling functions, for the debug "format" argument.
          *
          * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
          */

          createDebug.formatters = {};
          /**
          * Selects a color for a debug namespace
          * @param {String} namespace The namespace string for the for the debug instance to be colored
          * @return {Number|String} An ANSI color code for the given namespace
          * @api private
          */

          function selectColor(namespace) {
            var hash = 0;

            for (var i = 0; i < namespace.length; i++) {
              hash = (hash << 5) - hash + namespace.charCodeAt(i);
              hash |= 0; // Convert to 32bit integer
            }

            return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
          }

          createDebug.selectColor = selectColor;
          /**
          * Create a debugger with the given `namespace`.
          *
          * @param {String} namespace
          * @return {Function}
          * @api public
          */

          function createDebug(namespace) {
            var prevTime;

            function debug() {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              } // Disabled?


              if (!debug.enabled) {
                return;
              }

              var self = debug; // Set `diff` timestamp

              var curr = Number(new Date());
              var ms = curr - (prevTime || curr);
              self.diff = ms;
              self.prev = prevTime;
              self.curr = curr;
              prevTime = curr;
              args[0] = createDebug.coerce(args[0]);

              if (typeof args[0] !== 'string') {
                // Anything else let's inspect with %O
                args.unshift('%O');
              } // Apply any `formatters` transformations


              var index = 0;
              args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') {
                  return match;
                }

                index++;
                var formatter = createDebug.formatters[format];

                if (typeof formatter === 'function') {
                  var val = args[index];
                  match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

                  args.splice(index, 1);
                  index--;
                }

                return match;
              }); // Apply env-specific formatting (colors, etc.)

              createDebug.formatArgs.call(self, args);
              var logFn = self.log || createDebug.log;
              logFn.apply(self, args);
            }

            debug.namespace = namespace;
            debug.enabled = createDebug.enabled(namespace);
            debug.useColors = createDebug.useColors();
            debug.color = selectColor(namespace);
            debug.destroy = destroy;
            debug.extend = extend; // Debug.formatArgs = formatArgs;
            // debug.rawLog = rawLog;
            // env-specific initialization logic for debug instances

            if (typeof createDebug.init === 'function') {
              createDebug.init(debug);
            }

            createDebug.instances.push(debug);
            return debug;
          }

          function destroy() {
            var index = createDebug.instances.indexOf(this);

            if (index !== -1) {
              createDebug.instances.splice(index, 1);
              return true;
            }

            return false;
          }

          function extend(namespace, delimiter) {
            var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
            newDebug.log = this.log;
            return newDebug;
          }
          /**
          * Enables a debug mode by namespaces. This can include modes
          * separated by a colon and wildcards.
          *
          * @param {String} namespaces
          * @api public
          */


          function enable(namespaces) {
            createDebug.save(namespaces);
            createDebug.names = [];
            createDebug.skips = [];
            var i;
            var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
            var len = split.length;

            for (i = 0; i < len; i++) {
              if (!split[i]) {
                // ignore empty strings
                continue;
              }

              namespaces = split[i].replace(/\*/g, '.*?');

              if (namespaces[0] === '-') {
                createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
              } else {
                createDebug.names.push(new RegExp('^' + namespaces + '$'));
              }
            }

            for (i = 0; i < createDebug.instances.length; i++) {
              var instance = createDebug.instances[i];
              instance.enabled = createDebug.enabled(instance.namespace);
            }
          }
          /**
          * Disable debug output.
          *
          * @return {String} namespaces
          * @api public
          */


          function disable() {
            var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
              return '-' + namespace;
            }))).join(',');
            createDebug.enable('');
            return namespaces;
          }
          /**
          * Returns true if the given mode name is enabled, false otherwise.
          *
          * @param {String} name
          * @return {Boolean}
          * @api public
          */


          function enabled(name) {
            if (name[name.length - 1] === '*') {
              return true;
            }

            var i;
            var len;

            for (i = 0, len = createDebug.skips.length; i < len; i++) {
              if (createDebug.skips[i].test(name)) {
                return false;
              }
            }

            for (i = 0, len = createDebug.names.length; i < len; i++) {
              if (createDebug.names[i].test(name)) {
                return true;
              }
            }

            return false;
          }
          /**
          * Convert regexp to namespace
          *
          * @param {RegExp} regxep
          * @return {String} namespace
          * @api private
          */


          function toNamespace(regexp) {
            return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
          }
          /**
          * Coerce `val`.
          *
          * @param {Mixed} val
          * @return {Mixed}
          * @api private
          */


          function coerce(val) {
            if (val instanceof Error) {
              return val.stack || val.message;
            }

            return val;
          }

          createDebug.enable(createDebug.load());
          return createDebug;
        }

        module.exports = setup;
        /***/
      },

      /***/
      "./node_modules/process/browser.js":
      /*!*****************************************!*\
        !*** ./node_modules/process/browser.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesProcessBrowserJs(module, exports, __webpack_require__) {
        "use strict"; // shim for using process in browser

        var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
        // don't break things.  But we need to wrap it in a try catch in case it is
        // wrapped in strict mode code which doesn't define any globals.  It's inside a
        // function because try/catches deoptimize in certain engines.

        var cachedSetTimeout;
        var cachedClearTimeout;

        function defaultSetTimout() {
          throw new Error('setTimeout has not been defined');
        }

        function defaultClearTimeout() {
          throw new Error('clearTimeout has not been defined');
        }

        (function () {
          try {
            if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
            } else {
              cachedSetTimeout = defaultSetTimout;
            }
          } catch (e) {
            cachedSetTimeout = defaultSetTimout;
          }

          try {
            if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
            } else {
              cachedClearTimeout = defaultClearTimeout;
            }
          } catch (e) {
            cachedClearTimeout = defaultClearTimeout;
          }
        })();

        function runTimeout(fun) {
          if (cachedSetTimeout === setTimeout) {
            //normal enviroments in sane situations
            return setTimeout(fun, 0);
          } // if setTimeout wasn't available but was latter defined


          if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
            cachedSetTimeout = setTimeout;
            return setTimeout(fun, 0);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedSetTimeout(fun, 0);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
            }
          }
        }

        function runClearTimeout(marker) {
          if (cachedClearTimeout === clearTimeout) {
            //normal enviroments in sane situations
            return clearTimeout(marker);
          } // if clearTimeout wasn't available but was latter defined


          if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
            cachedClearTimeout = clearTimeout;
            return clearTimeout(marker);
          }

          try {
            // when when somebody has screwed with setTimeout but no I.E. maddness
            return cachedClearTimeout(marker);
          } catch (e) {
            try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
            } catch (e) {
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
            }
          }
        }

        var queue = [];
        var draining = false;
        var currentQueue;
        var queueIndex = -1;

        function cleanUpNextTick() {
          if (!draining || !currentQueue) {
            return;
          }

          draining = false;

          if (currentQueue.length) {
            queue = currentQueue.concat(queue);
          } else {
            queueIndex = -1;
          }

          if (queue.length) {
            drainQueue();
          }
        }

        function drainQueue() {
          if (draining) {
            return;
          }

          var timeout = runTimeout(cleanUpNextTick);
          draining = true;
          var len = queue.length;

          while (len) {
            currentQueue = queue;
            queue = [];

            while (++queueIndex < len) {
              if (currentQueue) {
                currentQueue[queueIndex].run();
              }
            }

            queueIndex = -1;
            len = queue.length;
          }

          currentQueue = null;
          draining = false;
          runClearTimeout(timeout);
        }

        process.nextTick = function (fun) {
          var args = new Array(arguments.length - 1);

          if (arguments.length > 1) {
            for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
            }
          }

          queue.push(new Item(fun, args));

          if (queue.length === 1 && !draining) {
            runTimeout(drainQueue);
          }
        }; // v8 likes predictible objects


        function Item(fun, array) {
          this.fun = fun;
          this.array = array;
        }

        Item.prototype.run = function () {
          this.fun.apply(null, this.array);
        };

        process.title = 'browser';
        process.browser = true;
        process.env = {};
        process.argv = [];
        process.version = ''; // empty string to avoid regexp issues

        process.versions = {};

        function noop() {}

        process.on = noop;
        process.addListener = noop;
        process.once = noop;
        process.off = noop;
        process.removeListener = noop;
        process.removeAllListeners = noop;
        process.emit = noop;
        process.prependListener = noop;
        process.prependOnceListener = noop;

        process.listeners = function (name) {
          return [];
        };

        process.binding = function (name) {
          throw new Error('process.binding is not supported');
        };

        process.cwd = function () {
          return '/';
        };

        process.chdir = function (dir) {
          throw new Error('process.chdir is not supported');
        };

        process.umask = function () {
          return 0;
        };
        /***/

      },

      /***/
      "./node_modules/style-loader/lib/addStyles.js":
      /*!****************************************************!*\
        !*** ./node_modules/style-loader/lib/addStyles.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesStyleLoaderLibAddStylesJs(module, exports, __webpack_require__) {
        /*
        	MIT License http://www.opensource.org/licenses/mit-license.php
        	Author Tobias Koppers @sokra
        */
        var stylesInDom = {};

        var memoize = function memoize(fn) {
          var memo;
          return function () {
            if (typeof memo === "undefined") memo = fn.apply(this, arguments);
            return memo;
          };
        };

        var isOldIE = memoize(function () {
          // Test for IE <= 9 as proposed by Browserhacks
          // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
          // Tests for existence of standard globals is to allow style-loader
          // to operate correctly into non-standard environments
          // @see https://github.com/webpack-contrib/style-loader/issues/177
          return window && document && document.all && !window.atob;
        });

        var getTarget = function getTarget(target, parent) {
          if (parent) {
            return parent.querySelector(target);
          }

          return document.querySelector(target);
        };

        var getElement = function (fn) {
          var memo = {};
          return function (target, parent) {
            // If passing function in options, then use it for resolve "head" element.
            // Useful for Shadow Root style i.e
            // {
            //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
            // }
            if (typeof target === 'function') {
              return target();
            }

            if (typeof memo[target] === "undefined") {
              var styleTarget = getTarget.call(this, target, parent); // Special case to return head of iframe instead of iframe itself

              if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  styleTarget = null;
                }
              }

              memo[target] = styleTarget;
            }

            return memo[target];
          };
        }();

        var singleton = null;
        var singletonCounter = 0;
        var stylesInsertedAtTop = [];

        var fixUrls = __webpack_require__(
        /*! ./urls */
        "./node_modules/style-loader/lib/urls.js");

        module.exports = function (list, options) {
          if (typeof DEBUG !== "undefined" && DEBUG) {
            if ((typeof document === "undefined" ? "undefined" : (0, _typeof3["default"])(document)) !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
          }

          options = options || {};
          options.attrs = (0, _typeof3["default"])(options.attrs) === "object" ? options.attrs : {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page

          if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE(); // By default, add <style> tags to the <head> element

          if (!options.insertInto) options.insertInto = "head"; // By default, add <style> tags to the bottom of the target

          if (!options.insertAt) options.insertAt = "bottom";
          var styles = listToStyles(list, options);
          addStylesToDom(styles, options);
          return function update(newList) {
            var mayRemove = [];

            for (var i = 0; i < styles.length; i++) {
              var item = styles[i];
              var domStyle = stylesInDom[item.id];
              domStyle.refs--;
              mayRemove.push(domStyle);
            }

            if (newList) {
              var newStyles = listToStyles(newList, options);
              addStylesToDom(newStyles, options);
            }

            for (var i = 0; i < mayRemove.length; i++) {
              var domStyle = mayRemove[i];

              if (domStyle.refs === 0) {
                for (var j = 0; j < domStyle.parts.length; j++) {
                  domStyle.parts[j]();
                }

                delete stylesInDom[domStyle.id];
              }
            }
          };
        };

        function addStylesToDom(styles, options) {
          for (var i = 0; i < styles.length; i++) {
            var item = styles[i];
            var domStyle = stylesInDom[item.id];

            if (domStyle) {
              domStyle.refs++;

              for (var j = 0; j < domStyle.parts.length; j++) {
                domStyle.parts[j](item.parts[j]);
              }

              for (; j < item.parts.length; j++) {
                domStyle.parts.push(addStyle(item.parts[j], options));
              }
            } else {
              var parts = [];

              for (var j = 0; j < item.parts.length; j++) {
                parts.push(addStyle(item.parts[j], options));
              }

              stylesInDom[item.id] = {
                id: item.id,
                refs: 1,
                parts: parts
              };
            }
          }
        }

        function listToStyles(list, options) {
          var styles = [];
          var newStyles = {};

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var css = item[1];
            var media = item[2];
            var sourceMap = item[3];
            var part = {
              css: css,
              media: media,
              sourceMap: sourceMap
            };
            if (!newStyles[id]) styles.push(newStyles[id] = {
              id: id,
              parts: [part]
            });else newStyles[id].parts.push(part);
          }

          return styles;
        }

        function insertStyleElement(options, style) {
          var target = getElement(options.insertInto);

          if (!target) {
            throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
          }

          var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

          if (options.insertAt === "top") {
            if (!lastStyleElementInsertedAtTop) {
              target.insertBefore(style, target.firstChild);
            } else if (lastStyleElementInsertedAtTop.nextSibling) {
              target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
            } else {
              target.appendChild(style);
            }

            stylesInsertedAtTop.push(style);
          } else if (options.insertAt === "bottom") {
            target.appendChild(style);
          } else if ((0, _typeof3["default"])(options.insertAt) === "object" && options.insertAt.before) {
            var nextSibling = getElement(options.insertAt.before, target);
            target.insertBefore(style, nextSibling);
          } else {
            throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
          }
        }

        function removeStyleElement(style) {
          if (style.parentNode === null) return false;
          style.parentNode.removeChild(style);
          var idx = stylesInsertedAtTop.indexOf(style);

          if (idx >= 0) {
            stylesInsertedAtTop.splice(idx, 1);
          }
        }

        function createStyleElement(options) {
          var style = document.createElement("style");

          if (options.attrs.type === undefined) {
            options.attrs.type = "text/css";
          }

          if (options.attrs.nonce === undefined) {
            var nonce = getNonce();

            if (nonce) {
              options.attrs.nonce = nonce;
            }
          }

          addAttrs(style, options.attrs);
          insertStyleElement(options, style);
          return style;
        }

        function createLinkElement(options) {
          var link = document.createElement("link");

          if (options.attrs.type === undefined) {
            options.attrs.type = "text/css";
          }

          options.attrs.rel = "stylesheet";
          addAttrs(link, options.attrs);
          insertStyleElement(options, link);
          return link;
        }

        function addAttrs(el, attrs) {
          Object.keys(attrs).forEach(function (key) {
            el.setAttribute(key, attrs[key]);
          });
        }

        function getNonce() {
          if (false) {}

          return __webpack_require__.nc;
        }

        function addStyle(obj, options) {
          var style, update, remove, result; // If a transform function was defined, run it on the css

          if (options.transform && obj.css) {
            result = typeof options.transform === 'function' ? options.transform(obj.css) : options.transform["default"](obj.css);

            if (result) {
              // If transform returns a value, use that instead of the original css.
              // This allows running runtime transformations on the css.
              obj.css = result;
            } else {
              // If the transform function returns a falsy value, don't add this css.
              // This allows conditional loading of css
              return function () {// noop
              };
            }
          }

          if (options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = createStyleElement(options));
            update = applyToSingletonTag.bind(null, style, styleIndex, false);
            remove = applyToSingletonTag.bind(null, style, styleIndex, true);
          } else if (obj.sourceMap && typeof URL === "function" && typeof URL.createObjectURL === "function" && typeof URL.revokeObjectURL === "function" && typeof Blob === "function" && typeof btoa === "function") {
            style = createLinkElement(options);
            update = updateLink.bind(null, style, options);

            remove = function remove() {
              removeStyleElement(style);
              if (style.href) URL.revokeObjectURL(style.href);
            };
          } else {
            style = createStyleElement(options);
            update = applyToTag.bind(null, style);

            remove = function remove() {
              removeStyleElement(style);
            };
          }

          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
                return;
              }

              update(obj = newObj);
            } else {
              remove();
            }
          };
        }

        var replaceText = function () {
          var textStore = [];
          return function (index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join('\n');
          };
        }();

        function applyToSingletonTag(style, index, remove, obj) {
          var css = remove ? "" : obj.css;

          if (style.styleSheet) {
            style.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = style.childNodes;
            if (childNodes[index]) style.removeChild(childNodes[index]);

            if (childNodes.length) {
              style.insertBefore(cssNode, childNodes[index]);
            } else {
              style.appendChild(cssNode);
            }
          }
        }

        function applyToTag(style, obj) {
          var css = obj.css;
          var media = obj.media;

          if (media) {
            style.setAttribute("media", media);
          }

          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            while (style.firstChild) {
              style.removeChild(style.firstChild);
            }

            style.appendChild(document.createTextNode(css));
          }
        }

        function updateLink(link, options, obj) {
          var css = obj.css;
          var sourceMap = obj.sourceMap;
          /*
          	If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
          	and there is no publicPath defined then lets turn convertToAbsoluteUrls
          	on by default.  Otherwise default to the convertToAbsoluteUrls option
          	directly
          */

          var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

          if (options.convertToAbsoluteUrls || autoFixUrls) {
            css = fixUrls(css);
          }

          if (sourceMap) {
            // http://stackoverflow.com/a/26603875
            css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
          }

          var blob = new Blob([css], {
            type: "text/css"
          });
          var oldSrc = link.href;
          link.href = URL.createObjectURL(blob);
          if (oldSrc) URL.revokeObjectURL(oldSrc);
        }
        /***/

      },

      /***/
      "./node_modules/style-loader/lib/urls.js":
      /*!***********************************************!*\
        !*** ./node_modules/style-loader/lib/urls.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesStyleLoaderLibUrlsJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /**
         * When source maps are enabled, `style-loader` uses a link element with a data-uri to
         * embed the css on the page. This breaks all relative urls because now they are relative to a
         * bundle instead of the current page.
         *
         * One solution is to only use full urls, but that may be impossible.
         *
         * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
         *
         * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
         *
         */


        module.exports = function (css) {
          // get current location
          var location = typeof window !== "undefined" && window.location;

          if (!location) {
            throw new Error("fixUrls requires window.location");
          } // blank or null?


          if (!css || typeof css !== "string") {
            return css;
          }

          var baseUrl = location.protocol + "//" + location.host;
          var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/"); // convert each url(...)

          /*
          This regular expression is just a way to recursively match brackets within
          a string.
          	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
             (  = Start a capturing group
               (?:  = Start a non-capturing group
                   [^)(]  = Match anything that isn't a parentheses
                   |  = OR
                   \(  = Match a start parentheses
                       (?:  = Start another non-capturing groups
                           [^)(]+  = Match anything that isn't a parentheses
                           |  = OR
                           \(  = Match a start parentheses
                               [^)(]*  = Match anything that isn't a parentheses
                           \)  = Match a end parentheses
                       )  = End Group
                       *\) = Match anything and then a close parens
                   )  = Close non-capturing group
                   *  = Match anything
                )  = Close capturing group
           \)  = Match a close parens
          	 /gi  = Get all matches, not the first.  Be case insensitive.
           */

          var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (fullMatch, origUrl) {
            // strip quotes (if they exist)
            var unquotedOrigUrl = origUrl.trim().replace(/^"(.*)"$/, function (o, $1) {
              return $1;
            }).replace(/^'(.*)'$/, function (o, $1) {
              return $1;
            }); // already a full url? no change

            if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
              return fullMatch;
            } // convert the url to a full url


            var newUrl;

            if (unquotedOrigUrl.indexOf("//") === 0) {
              //TODO: should we add protocol?
              newUrl = unquotedOrigUrl;
            } else if (unquotedOrigUrl.indexOf("/") === 0) {
              // path should be relative to the base url
              newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
            } else {
              // path should be relative to current directory
              newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
            } // send back the fixed url(...)


            return "url(" + JSON.stringify(newUrl) + ")";
          }); // send back the fixed css

          return fixedCss;
        };
        /***/

      },

      /***/
      "./node_modules/tiny-emitter/index.js":
      /*!********************************************!*\
        !*** ./node_modules/tiny-emitter/index.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesTinyEmitterIndexJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");

        function E() {// Keep this empty so it's easier to inherit from
          // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
        }

        E.prototype = {
          on: function on(name, callback, ctx) {
            var e = this.e || (this.e = {});
            (e[name] || (e[name] = [])).push({
              fn: callback,
              ctx: ctx
            });
            return this;
          },
          once: function once(name, callback, ctx) {
            var self = this;

            function listener() {
              self.off(name, listener);
              callback.apply(ctx, arguments);
            }

            ;
            listener._ = callback;
            return this.on(name, listener, ctx);
          },
          emit: function emit(name) {
            var data = [].slice.call(arguments, 1);
            var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
            var i = 0;
            var len = evtArr.length;

            for (i; i < len; i++) {
              evtArr[i].fn.apply(evtArr[i].ctx, data);
            }

            return this;
          },
          off: function off(name, callback) {
            var e = this.e || (this.e = {});
            var evts = e[name];
            var liveEvents = [];

            if (evts && callback) {
              for (var i = 0, len = evts.length; i < len; i++) {
                if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
              }
            } // Remove event from queue to prevent memory leak
            // Suggested by https://github.com/lazd
            // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910


            liveEvents.length ? e[name] = liveEvents : delete e[name];
            return this;
          }
        };
        module.exports = E;
        module.exports.TinyEmitter = E;
        /***/
      },

      /***/
      "./node_modules/url-polyfill/url-polyfill.js":
      /*!***************************************************!*\
        !*** ./node_modules/url-polyfill/url-polyfill.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesUrlPolyfillUrlPolyfillJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          __webpack_require__(
          /*! core-js/modules/es6.regexp.search */
          "./node_modules/core-js/modules/es6.regexp.search.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.split */
          "./node_modules/core-js/modules/es6.regexp.split.js");

          __webpack_require__(
          /*! core-js/modules/es6.array.iterator */
          "./node_modules/core-js/modules/es6.array.iterator.js");

          __webpack_require__(
          /*! core-js/modules/es6.function.name */
          "./node_modules/core-js/modules/es6.function.name.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.to-string */
          "./node_modules/core-js/modules/es6.regexp.to-string.js");

          __webpack_require__(
          /*! core-js/modules/es6.date.to-string */
          "./node_modules/core-js/modules/es6.date.to-string.js");

          __webpack_require__(
          /*! core-js/modules/web.dom.iterable */
          "./node_modules/core-js/modules/web.dom.iterable.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.replace */
          "./node_modules/core-js/modules/es6.regexp.replace.js");

          __webpack_require__(
          /*! core-js/modules/es7.symbol.async-iterator */
          "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

          __webpack_require__(
          /*! core-js/modules/es6.symbol */
          "./node_modules/core-js/modules/es6.symbol.js");

          function _typeof(obj) {
            if (typeof Symbol === "function" && (0, _typeof3["default"])(Symbol.iterator) === "symbol") {
              _typeof = function _typeof(obj) {
                return (0, _typeof3["default"])(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3["default"])(obj);
              };
            }

            return _typeof(obj);
          }

          (function (global) {
            /**
             * Polyfill URLSearchParams
             *
             * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
             */
            var checkIfIteratorIsSupported = function checkIfIteratorIsSupported() {
              try {
                return !!Symbol.iterator;
              } catch (error) {
                return false;
              }
            };

            var iteratorSupported = checkIfIteratorIsSupported();

            var createIterator = function createIterator(items) {
              var iterator = {
                next: function next() {
                  var value = items.shift();
                  return {
                    done: value === void 0,
                    value: value
                  };
                }
              };

              if (iteratorSupported) {
                iterator[Symbol.iterator] = function () {
                  return iterator;
                };
              }

              return iterator;
            };
            /**
             * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
             * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
             */


            var serializeParam = function serializeParam(value) {
              return encodeURIComponent(value).replace(/%20/g, '+');
            };

            var deserializeParam = function deserializeParam(value) {
              return decodeURIComponent(String(value).replace(/\+/g, ' '));
            };

            var polyfillURLSearchParams = function polyfillURLSearchParams() {
              var URLSearchParams = function URLSearchParams(searchString) {
                Object.defineProperty(this, '_entries', {
                  writable: true,
                  value: {}
                });

                var typeofSearchString = _typeof(searchString);

                if (typeofSearchString === 'undefined') {// do nothing
                } else if (typeofSearchString === 'string') {
                  if (searchString !== '') {
                    this._fromString(searchString);
                  }
                } else if (searchString instanceof URLSearchParams) {
                  var _this = this;

                  searchString.forEach(function (value, name) {
                    _this.append(name, value);
                  });
                } else if (searchString !== null && typeofSearchString === 'object') {
                  if (Object.prototype.toString.call(searchString) === '[object Array]') {
                    for (var i = 0; i < searchString.length; i++) {
                      var entry = searchString[i];

                      if (Object.prototype.toString.call(entry) === '[object Array]' || entry.length !== 2) {
                        this.append(entry[0], entry[1]);
                      } else {
                        throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
                      }
                    }
                  } else {
                    for (var key in searchString) {
                      if (searchString.hasOwnProperty(key)) {
                        this.append(key, searchString[key]);
                      }
                    }
                  }
                } else {
                  throw new TypeError('Unsupported input\'s type for URLSearchParams');
                }
              };

              var proto = URLSearchParams.prototype;

              proto.append = function (name, value) {
                if (name in this._entries) {
                  this._entries[name].push(String(value));
                } else {
                  this._entries[name] = [String(value)];
                }
              };

              proto["delete"] = function (name) {
                delete this._entries[name];
              };

              proto.get = function (name) {
                return name in this._entries ? this._entries[name][0] : null;
              };

              proto.getAll = function (name) {
                return name in this._entries ? this._entries[name].slice(0) : [];
              };

              proto.has = function (name) {
                return name in this._entries;
              };

              proto.set = function (name, value) {
                this._entries[name] = [String(value)];
              };

              proto.forEach = function (callback, thisArg) {
                var entries;

                for (var name in this._entries) {
                  if (this._entries.hasOwnProperty(name)) {
                    entries = this._entries[name];

                    for (var i = 0; i < entries.length; i++) {
                      callback.call(thisArg, entries[i], name, this);
                    }
                  }
                }
              };

              proto.keys = function () {
                var items = [];
                this.forEach(function (value, name) {
                  items.push(name);
                });
                return createIterator(items);
              };

              proto.values = function () {
                var items = [];
                this.forEach(function (value) {
                  items.push(value);
                });
                return createIterator(items);
              };

              proto.entries = function () {
                var items = [];
                this.forEach(function (value, name) {
                  items.push([name, value]);
                });
                return createIterator(items);
              };

              if (iteratorSupported) {
                proto[Symbol.iterator] = proto.entries;
              }

              proto.toString = function () {
                var searchArray = [];
                this.forEach(function (value, name) {
                  searchArray.push(serializeParam(name) + '=' + serializeParam(value));
                });
                return searchArray.join('&');
              };

              global.URLSearchParams = URLSearchParams;
            };

            var checkIfURLSearchParamsSupported = function checkIfURLSearchParamsSupported() {
              try {
                var URLSearchParams = global.URLSearchParams;
                return new URLSearchParams('?a=1').toString() === 'a=1' && typeof URLSearchParams.prototype.set === 'function';
              } catch (e) {
                return false;
              }
            };

            if (!checkIfURLSearchParamsSupported()) {
              polyfillURLSearchParams();
            }

            var proto = global.URLSearchParams.prototype;

            if (typeof proto.sort !== 'function') {
              proto.sort = function () {
                var _this = this;

                var items = [];
                this.forEach(function (value, name) {
                  items.push([name, value]);

                  if (!_this._entries) {
                    _this["delete"](name);
                  }
                });
                items.sort(function (a, b) {
                  if (a[0] < b[0]) {
                    return -1;
                  } else if (a[0] > b[0]) {
                    return +1;
                  } else {
                    return 0;
                  }
                });

                if (_this._entries) {
                  // force reset because IE keeps keys index
                  _this._entries = {};
                }

                for (var i = 0; i < items.length; i++) {
                  this.append(items[i][0], items[i][1]);
                }
              };
            }

            if (typeof proto._fromString !== 'function') {
              Object.defineProperty(proto, '_fromString', {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function value(searchString) {
                  if (this._entries) {
                    this._entries = {};
                  } else {
                    var keys = [];
                    this.forEach(function (value, name) {
                      keys.push(name);
                    });

                    for (var i = 0; i < keys.length; i++) {
                      this["delete"](keys[i]);
                    }
                  }

                  searchString = searchString.replace(/^\?/, '');
                  var attributes = searchString.split('&');
                  var attribute;

                  for (var i = 0; i < attributes.length; i++) {
                    attribute = attributes[i].split('=');
                    this.append(deserializeParam(attribute[0]), attribute.length > 1 ? deserializeParam(attribute[1]) : '');
                  }
                }
              });
            } // HTMLAnchorElement

          })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : void 0);

          (function (global) {
            /**
             * Polyfill URL
             *
             * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
             */
            var checkIfURLIsSupported = function checkIfURLIsSupported() {
              try {
                var u = new global.URL('b', 'http://a');
                u.pathname = 'c d';
                return u.href === 'http://a/c%20d' && u.searchParams;
              } catch (e) {
                return false;
              }
            };

            var polyfillURL = function polyfillURL() {
              var _URL = global.URL;

              var URL = function URL(url, base) {
                if (typeof url !== 'string') url = String(url); // Only create another document if the base is different from current location.

                var doc = document,
                    baseElement;

                if (base && (global.location === void 0 || base !== global.location.href)) {
                  doc = document.implementation.createHTMLDocument('');
                  baseElement = doc.createElement('base');
                  baseElement.href = base;
                  doc.head.appendChild(baseElement);

                  try {
                    if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                  } catch (err) {
                    throw new Error('URL unable to set base ' + base + ' due to ' + err);
                  }
                }

                var anchorElement = doc.createElement('a');
                anchorElement.href = url;

                if (baseElement) {
                  doc.body.appendChild(anchorElement);
                  anchorElement.href = anchorElement.href; // force href to refresh
                }

                if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href)) {
                  throw new TypeError('Invalid URL');
                }

                Object.defineProperty(this, '_anchorElement', {
                  value: anchorElement
                }); // create a linked searchParams which reflect its changes on URL

                var searchParams = new global.URLSearchParams(this.search);
                var enableSearchUpdate = true;
                var enableSearchParamsUpdate = true;

                var _this = this;

                ['append', 'delete', 'set'].forEach(function (methodName) {
                  var method = searchParams[methodName];

                  searchParams[methodName] = function () {
                    method.apply(searchParams, arguments);

                    if (enableSearchUpdate) {
                      enableSearchParamsUpdate = false;
                      _this.search = searchParams.toString();
                      enableSearchParamsUpdate = true;
                    }
                  };
                });
                Object.defineProperty(this, 'searchParams', {
                  value: searchParams,
                  enumerable: true
                });
                var search = void 0;
                Object.defineProperty(this, '_updateSearchParams', {
                  enumerable: false,
                  configurable: false,
                  writable: false,
                  value: function value() {
                    if (this.search !== search) {
                      search = this.search;

                      if (enableSearchParamsUpdate) {
                        enableSearchUpdate = false;

                        this.searchParams._fromString(this.search);

                        enableSearchUpdate = true;
                      }
                    }
                  }
                });
              };

              var proto = URL.prototype;

              var linkURLWithAnchorAttribute = function linkURLWithAnchorAttribute(attributeName) {
                Object.defineProperty(proto, attributeName, {
                  get: function get() {
                    return this._anchorElement[attributeName];
                  },
                  set: function set(value) {
                    this._anchorElement[attributeName] = value;
                  },
                  enumerable: true
                });
              };

              ['hash', 'host', 'hostname', 'port', 'protocol'].forEach(function (attributeName) {
                linkURLWithAnchorAttribute(attributeName);
              });
              Object.defineProperty(proto, 'search', {
                get: function get() {
                  return this._anchorElement['search'];
                },
                set: function set(value) {
                  this._anchorElement['search'] = value;

                  this._updateSearchParams();
                },
                enumerable: true
              });
              Object.defineProperties(proto, {
                'toString': {
                  get: function get() {
                    var _this = this;

                    return function () {
                      return _this.href;
                    };
                  }
                },
                'href': {
                  get: function get() {
                    return this._anchorElement.href.replace(/\?$/, '');
                  },
                  set: function set(value) {
                    this._anchorElement.href = value;

                    this._updateSearchParams();
                  },
                  enumerable: true
                },
                'pathname': {
                  get: function get() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, '/');
                  },
                  set: function set(value) {
                    this._anchorElement.pathname = value;
                  },
                  enumerable: true
                },
                'origin': {
                  get: function get() {
                    // get expected port from protocol
                    var expectedPort = {
                      'http:': 80,
                      'https:': 443,
                      'ftp:': 21
                    }[this._anchorElement.protocol]; // add port to origin if, expected port is different than actual port
                    // and it is not empty f.e http://foo:8080
                    // 8080 != 80 && 8080 != ''

                    var addPortToOrigin = this._anchorElement.port != expectedPort && this._anchorElement.port !== '';
                    return this._anchorElement.protocol + '//' + this._anchorElement.hostname + (addPortToOrigin ? ':' + this._anchorElement.port : '');
                  },
                  enumerable: true
                },
                'password': {
                  // TODO
                  get: function get() {
                    return '';
                  },
                  set: function set(value) {},
                  enumerable: true
                },
                'username': {
                  // TODO
                  get: function get() {
                    return '';
                  },
                  set: function set(value) {},
                  enumerable: true
                }
              });

              URL.createObjectURL = function (blob) {
                return _URL.createObjectURL.apply(_URL, arguments);
              };

              URL.revokeObjectURL = function (url) {
                return _URL.revokeObjectURL.apply(_URL, arguments);
              };

              global.URL = URL;
            };

            if (!checkIfURLIsSupported()) {
              polyfillURL();
            }

            if (global.location !== void 0 && !('origin' in global.location)) {
              var getOrigin = function getOrigin() {
                return global.location.protocol + '//' + global.location.hostname + (global.location.port ? ':' + global.location.port : '');
              };

              try {
                Object.defineProperty(global.location, 'origin', {
                  get: getOrigin,
                  enumerable: true
                });
              } catch (e) {
                setInterval(function () {
                  global.location.origin = getOrigin();
                }, 100);
              }
            }
          })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : void 0);
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/url-search-params-polyfill/index.js":
      /*!**********************************************************!*\
        !*** ./node_modules/url-search-params-polyfill/index.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesUrlSearchParamsPolyfillIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */

        (function (global) {
          __webpack_require__(
          /*! core-js/modules/es7.symbol.async-iterator */
          "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

          __webpack_require__(
          /*! core-js/modules/es6.symbol */
          "./node_modules/core-js/modules/es6.symbol.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.split */
          "./node_modules/core-js/modules/es6.regexp.split.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.replace */
          "./node_modules/core-js/modules/es6.regexp.replace.js");

          __webpack_require__(
          /*! core-js/modules/es6.array.iterator */
          "./node_modules/core-js/modules/es6.array.iterator.js");

          __webpack_require__(
          /*! core-js/modules/web.dom.iterable */
          "./node_modules/core-js/modules/web.dom.iterable.js");

          __webpack_require__(
          /*! core-js/modules/es6.function.name */
          "./node_modules/core-js/modules/es6.function.name.js");

          __webpack_require__(
          /*! core-js/modules/es6.regexp.to-string */
          "./node_modules/core-js/modules/es6.regexp.to-string.js");

          __webpack_require__(
          /*! core-js/modules/es6.date.to-string */
          "./node_modules/core-js/modules/es6.date.to-string.js");

          function _typeof(obj) {
            if (typeof Symbol === "function" && (0, _typeof3["default"])(Symbol.iterator) === "symbol") {
              _typeof = function _typeof(obj) {
                return (0, _typeof3["default"])(obj);
              };
            } else {
              _typeof = function _typeof(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3["default"])(obj);
              };
            }

            return _typeof(obj);
          }
          /**
           *
           *
           * @author Jerry Bendy <jerry@icewingcc.com>
           * @licence MIT
           *
           */


          (function (self) {
            'use strict';

            var nativeURLSearchParams = self.URLSearchParams ? self.URLSearchParams : null,
                isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({
              a: 1
            }).toString() === 'a=1',
                // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
            decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams('s=%2B').get('s') === '+',
                __URLSearchParams__ = "__URLSearchParams__",
                // Fix bug in Edge which cannot encode ' &' correctly
            encodesAmpersandsCorrectly = nativeURLSearchParams ? function () {
              var ampersandTest = new nativeURLSearchParams();
              ampersandTest.append('s', ' &');
              return ampersandTest.toString() === 's=+%26';
            }() : true,
                prototype = URLSearchParamsPolyfill.prototype,
                iterable = !!(self.Symbol && self.Symbol.iterator);

            if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
              return;
            }
            /**
             * Make a URLSearchParams instance
             *
             * @param {object|string|URLSearchParams} search
             * @constructor
             */


            function URLSearchParamsPolyfill(search) {
              search = search || ""; // support construct object with another URLSearchParams instance

              if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
                search = search.toString();
              }

              this[__URLSearchParams__] = parseToDict(search);
            }
            /**
             * Appends a specified key/value pair as a new search parameter.
             *
             * @param {string} name
             * @param {string} value
             */


            prototype.append = function (name, value) {
              appendTo(this[__URLSearchParams__], name, value);
            };
            /**
             * Deletes the given search parameter, and its associated value,
             * from the list of all search parameters.
             *
             * @param {string} name
             */


            prototype["delete"] = function (name) {
              delete this[__URLSearchParams__][name];
            };
            /**
             * Returns the first value associated to the given search parameter.
             *
             * @param {string} name
             * @returns {string|null}
             */


            prototype.get = function (name) {
              var dict = this[__URLSearchParams__];
              return name in dict ? dict[name][0] : null;
            };
            /**
             * Returns all the values association with a given search parameter.
             *
             * @param {string} name
             * @returns {Array}
             */


            prototype.getAll = function (name) {
              var dict = this[__URLSearchParams__];
              return name in dict ? dict[name].slice(0) : [];
            };
            /**
             * Returns a Boolean indicating if such a search parameter exists.
             *
             * @param {string} name
             * @returns {boolean}
             */


            prototype.has = function (name) {
              return name in this[__URLSearchParams__];
            };
            /**
             * Sets the value associated to a given search parameter to
             * the given value. If there were several values, delete the
             * others.
             *
             * @param {string} name
             * @param {string} value
             */


            prototype.set = function set(name, value) {
              this[__URLSearchParams__][name] = ['' + value];
            };
            /**
             * Returns a string containg a query string suitable for use in a URL.
             *
             * @returns {string}
             */


            prototype.toString = function () {
              var dict = this[__URLSearchParams__],
                  query = [],
                  i,
                  key,
                  name,
                  value;

              for (key in dict) {
                name = encode(key);

                for (i = 0, value = dict[key]; i < value.length; i++) {
                  query.push(name + '=' + encode(value[i]));
                }
              }

              return query.join('&');
            }; // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.


            var forSureUsePolyfill = !decodesPlusesCorrectly;
            var useProxy = !forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy;
            /*
             * Apply polifill to global object and append other prototype into it
             */

            self.URLSearchParams = useProxy ? // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
            new Proxy(nativeURLSearchParams, {
              construct: function construct(target, args) {
                return new target(new URLSearchParamsPolyfill(args[0]).toString());
              }
            }) : URLSearchParamsPolyfill;
            var USPProto = self.URLSearchParams.prototype;
            USPProto.polyfill = true;
            /**
             *
             * @param {function} callback
             * @param {object} thisArg
             */

            USPProto.forEach = USPProto.forEach || function (callback, thisArg) {
              var dict = parseToDict(this.toString());
              Object.getOwnPropertyNames(dict).forEach(function (name) {
                dict[name].forEach(function (value) {
                  callback.call(thisArg, value, name, this);
                }, this);
              }, this);
            };
            /**
             * Sort all name-value pairs
             */


            USPProto.sort = USPProto.sort || function () {
              var dict = parseToDict(this.toString()),
                  keys = [],
                  k,
                  i,
                  j;

              for (k in dict) {
                keys.push(k);
              }

              keys.sort();

              for (i = 0; i < keys.length; i++) {
                this["delete"](keys[i]);
              }

              for (i = 0; i < keys.length; i++) {
                var key = keys[i],
                    values = dict[key];

                for (j = 0; j < values.length; j++) {
                  this.append(key, values[j]);
                }
              }
            };
            /**
             * Returns an iterator allowing to go through all keys of
             * the key/value pairs contained in this object.
             *
             * @returns {function}
             */


            USPProto.keys = USPProto.keys || function () {
              var items = [];
              this.forEach(function (item, name) {
                items.push(name);
              });
              return makeIterator(items);
            };
            /**
             * Returns an iterator allowing to go through all values of
             * the key/value pairs contained in this object.
             *
             * @returns {function}
             */


            USPProto.values = USPProto.values || function () {
              var items = [];
              this.forEach(function (item) {
                items.push(item);
              });
              return makeIterator(items);
            };
            /**
             * Returns an iterator allowing to go through all key/value
             * pairs contained in this object.
             *
             * @returns {function}
             */


            USPProto.entries = USPProto.entries || function () {
              var items = [];
              this.forEach(function (item, name) {
                items.push([name, item]);
              });
              return makeIterator(items);
            };

            if (iterable) {
              USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
            }

            function encode(str) {
              var replace = {
                '!': '%21',
                "'": '%27',
                '(': '%28',
                ')': '%29',
                '~': '%7E',
                '%20': '+',
                '%00': '\x00'
              };
              return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function (match) {
                return replace[match];
              });
            }

            function decode(str) {
              return decodeURIComponent(str.replace(/\+/g, ' '));
            }

            function makeIterator(arr) {
              var iterator = {
                next: function next() {
                  var value = arr.shift();
                  return {
                    done: value === undefined,
                    value: value
                  };
                }
              };

              if (iterable) {
                iterator[self.Symbol.iterator] = function () {
                  return iterator;
                };
              }

              return iterator;
            }

            function parseToDict(search) {
              var dict = {};

              if (_typeof(search) === "object") {
                for (var key in search) {
                  if (search.hasOwnProperty(key)) {
                    appendTo(dict, key, search[key]);
                  }
                }
              } else {
                // remove first '?'
                if (search.indexOf("?") === 0) {
                  search = search.slice(1);
                }

                var pairs = search.split("&");

                for (var j = 0; j < pairs.length; j++) {
                  var value = pairs[j],
                      index = value.indexOf('=');

                  if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                  } else {
                    if (value) {
                      appendTo(dict, decode(value), '');
                    }
                  }
                }
              }

              return dict;
            }

            function appendTo(dict, name, value) {
              var val = typeof value === 'string' ? value : value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value);

              if (name in dict) {
                dict[name].push(val);
              } else {
                dict[name] = [val];
              }
            }
          })(typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : void 0);
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/webpack/buildin/global.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/global.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinGlobalJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");

        function _typeof(obj) {
          if (typeof Symbol === "function" && (0, _typeof3["default"])(Symbol.iterator) === "symbol") {
            _typeof = function _typeof(obj) {
              return (0, _typeof3["default"])(obj);
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3["default"])(obj);
            };
          }

          return _typeof(obj);
        }

        var g; // This works in non-strict mode

        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
        } // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}


        module.exports = g;
        /***/
      },

      /***/
      "./src/defaults.js":
      /*!*************************!*\
        !*** ./src/defaults.js ***!
        \*************************/

      /*! no static exports found */

      /***/
      function srcDefaultsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _settings = _interopRequireDefault(__webpack_require__(
        /*! ./settings */
        "./src/settings.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        var _default = {
          allowCancel: true,
          debug: false,
          locale: _settings["default"].locales.EN_US,
          skipDomainVerification: false,
          testMode: false,
          timeout: 30000 // 30 seconds

        };
        exports["default"] = _default;
        /***/
      },

      /***/
      "./src/embedded.js":
      /*!*************************!*\
        !*** ./src/embedded.js ***!
        \*************************/

      /*! no static exports found */

      /***/
      function srcEmbeddedJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "./node_modules/core-js/modules/es6.object.freeze.js");

        __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");

        __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");

        __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");

        __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");

        __webpack_require__(
        /*! core-js/modules/es6.reflect.get */
        "./node_modules/core-js/modules/es6.reflect.get.js");

        __webpack_require__(
        /*! core-js/modules/es6.object.set-prototype-of */
        "./node_modules/core-js/modules/es6.object.set-prototype-of.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");

        __webpack_require__(
        /*! core-js/modules/es6.date.to-string */
        "./node_modules/core-js/modules/es6.date.to-string.js");

        __webpack_require__(
        /*! core-js/modules/es6.regexp.search */
        "./node_modules/core-js/modules/es6.regexp.search.js");

        __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");

        __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");

        var _tinyEmitter = _interopRequireDefault(__webpack_require__(
        /*! tiny-emitter */
        "./node_modules/tiny-emitter/index.js"));

        var _commonTags = __webpack_require__(
        /*! common-tags */
        "./node_modules/common-tags/es/index.js");

        var _debug = _interopRequireDefault(__webpack_require__(
        /*! ./utils/debug */
        "./src/utils/debug.js"));

        var _defaults = _interopRequireDefault(__webpack_require__(
        /*! ./defaults */
        "./src/defaults.js"));

        var _settings = _interopRequireDefault(__webpack_require__(
        /*! ./settings */
        "./src/settings.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }

        function _templateObject4() {
          var data = _taggedTemplateLiteral(["\n            <iframe class=\"", "\" name=\"", "\" src=\"", "\" scrolling=\"no\" />\n          </div>\n        </div>\n      "]);

          _templateObject4 = function _templateObject4() {
            return data;
          };

          return data;
        }

        function _templateObject3() {
          var data = _taggedTemplateLiteral(["\n          <div class=", ">\n            <button class=", " role=\"button\" title=\"Close signature request\"></button>\n          </div>\n        "]);

          _templateObject3 = function _templateObject3() {
            return data;
          };

          return data;
        }

        function _templateObject2() {
          var data = _taggedTemplateLiteral(["\n        <div class=\"", " ", "\">\n          <div class=\"", "\"></div>\n          <div class=\"", "\">\n      "]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _taggedTemplateLiteral(["\n        <div class=\"", "\">\n          <iframe class=\"", "\" name=\"", "\" src=\"", "\" scrolling=\"no\" />\n        </div>\n      "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        function _taggedTemplateLiteral(strings, raw) {
          if (!raw) {
            raw = strings.slice(0);
          }

          return Object.freeze(Object.defineProperties(strings, {
            raw: {
              value: Object.freeze(raw)
            }
          }));
        }

        function _objectSpread(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);

            if (typeof Object.getOwnPropertySymbols === 'function') {
              ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
              }));
            }

            ownKeys.forEach(function (key) {
              _defineProperty(target, key, source[key]);
            });
          }

          return target;
        }

        function _typeof(obj) {
          if (typeof Symbol === "function" && (0, _typeof3["default"])(Symbol.iterator) === "symbol") {
            _typeof = function _typeof(obj) {
              return (0, _typeof3["default"])(obj);
            };
          } else {
            _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : (0, _typeof3["default"])(obj);
            };
          }

          return _typeof(obj);
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }

          return _assertThisInitialized(self);
        }

        function _get(target, property, receiver) {
          if (typeof Reflect !== "undefined" && Reflect.get) {
            _get = Reflect.get;
          } else {
            _get = function _get(target, property, receiver) {
              var base = _superPropBase(target, property);

              if (!base) return;
              var desc = Object.getOwnPropertyDescriptor(base, property);

              if (desc.get) {
                return desc.get.call(receiver);
              }

              return desc.value;
            };
          }

          return _get(target, property, receiver || target);
        }

        function _superPropBase(object, property) {
          while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = _getPrototypeOf(object);
            if (object === null) break;
          }

          return object;
        }

        function _getPrototypeOf(o) {
          _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) _setPrototypeOf(subClass, superClass);
        }

        function _setPrototypeOf(o, p) {
          _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };

          return _setPrototypeOf(o, p);
        }

        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return self;
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        var HelloSign =
        /*#__PURE__*/
        function (_Emitter) {
          _inherits(HelloSign, _Emitter);
          /**
           * HelloSign Embedded class names.
           *
           * @enum {string}
           * @static
           * @readonly
           */

          /**
           * HelloSign Embedded events.
           *
           * @enum {string}
           * @static
           * @readonly
           */

          /**
           * HelloSign Embedded supported locales.
           *
           * @enum {string}
           * @static
           * @readonly
           */

          /**
           * HelloSign Embedded cross-origin window messages.
           *
           * @enum {string}
           * @static
           * @readonly
           */

          /**
           * HelloSign Embedded version number.
           *
           * @enum {string}
           * @static
           * @readonly
           */

          /**
           * The base config object which "open" will extend.
           *
           * @type {?Object}
           * @private
           */

          /**
           * A reference to the base HelloSign Embedded container
           * element.
           *
           * @type {?HTMLElement}
           * @private
           */

          /**
           * The final config object.
           *
           * @type {?Object}
           * @private
           */

          /**
           * The iFrame URL object.
           *
           * @type {?URL}
           * @private
           */

          /**
           * A reference to the iFrame element.
           *
           * @type {?HTMLElement}
           * @private
           */

          /**
           * The initialization timeout timer.
           *
           * @type {?number}
           * @private
           */

          /**
           * Whether the client is open or not.
           *
           * @type {boolean}
           * @private
           */

          /**
           * Whether the app is ready or not.
           *
           * @type {boolean}
           * @private
           */

          /**
           * Whether the signature request has been sent or signed.
           *
           * @type {boolean}
           * @private
           */

          /**
           * @type {Function}
           * @private
           */

          /**
           * @type {Function}
           * @private
           */

          /**
           * @type {Function}
           * @private
           */

          /**
           * @type {Function}
           * @private
           */

          /**
           * Creates a new HelloSign Embedded instance.
           *
           * @param {Object} [obj]
           * @constructor
           */


          function HelloSign() {
            var _this;

            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _classCallCheck(this, HelloSign);

            _this = _possibleConstructorReturn(this, _getPrototypeOf(HelloSign).call(this));

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_baseConfig", null);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_baseEl", null);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_config", null);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_iFrameURL", null);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_iFrameEl", null);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_initTimeout", null);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_isOpen", false);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_isReady", false);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_isSentOrSigned", false);

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_onEmbeddedClick", _this._onEmbeddedClick.bind(_assertThisInitialized(_assertThisInitialized(_this))));

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_onInitTimeout", _this._onInitTimeout.bind(_assertThisInitialized(_assertThisInitialized(_this))));

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_onBeforeUnload", _this._onBeforeUnload.bind(_assertThisInitialized(_assertThisInitialized(_this))));

            _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_onMessage", _this._onMessage.bind(_assertThisInitialized(_assertThisInitialized(_this))));

            _debug["default"].info('created new HelloSign instance with options', obj);

            if (obj && _typeof(obj) === 'object') {
              _this._baseConfig = _objectSpread({}, obj);
            } else {
              throw new TypeError('Configuration must be an object');
            }

            return _this;
          }
          /**
           * Validates and appends the "client_id" parameter to the
           * iFrame params object.
           *
           * @throws {TypeError} if clientId is invalid
           * @param {URLSearchParams} params
           * @private
           */


          _createClass(HelloSign, [{
            key: "_applyClientId",
            value: function _applyClientId(params) {
              var val = this._config.clientId;

              if (!val) {
                throw new TypeError('"clientId" is required');
              }

              if (typeof val !== 'string') {
                throw new TypeError('"clientId" must be a string');
              }

              params.append('client_id', val);
            }
            /**
             * Validates and appends the "debug" parameter to the
             * iFrame params object.
             *
             * @throws {TypeError} if debug is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyDebug",
            value: function _applyDebug(params) {
              var val = this._config.debug;

              if (typeof val !== 'boolean') {
                throw new TypeError('"debug" must be a boolean');
              }

              params.append('debug', val ? 1 : 0);
            }
            /**
             * Validates and appends the "final_button_text" parameter
             * to the iFrame params object.
             *
             * @throws {TypeError} if finalButtonText is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyFinalButtonText",
            value: function _applyFinalButtonText(params) {
              if ('finalButtonText' in this._config) {
                var val = this._config.finalButtonText;

                if (typeof val !== 'string') {
                  throw new TypeError('"finalButtonText" must be a string');
                }

                if (!['Save', 'Send', 'Continue'].includes(val)) {
                  throw new TypeError('"finalButtonText" must be one of "Save", "Send", or "Continue"');
                }

                params.append('final_button_text', val);
              }
            }
            /**
             * Validates and appends the "hide_header" parameter to the
             * iFrame params object.
             *
             * @throws {TypeError} if hideHeader is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyHideHeader",
            value: function _applyHideHeader(params) {
              if ('hideHeader' in this._config) {
                var val = this._config.hideHeader;

                if (typeof val !== 'boolean') {
                  throw new TypeError('"hideHeader" must be a boolean');
                }

                params.append('hide_header', val);
              }
            }
            /**
             * Validates and appends the "user_culture" parameter to
             * the iFrame params object.
             *
             * @throws {TypeError} if locale is not a string
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyLocale",
            value: function _applyLocale(params) {
              var val = this._config.locale;

              if (typeof val !== 'string') {
                throw new TypeError('"locale" must be a string');
              }

              params.append('user_culture', val);
            }
            /**
             * Appends the "parent_url" parameter to the iFrame params
             * object.
             *
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyParentURL",
            value: function _applyParentURL(params) {
              params.append('parent_url', document.location.href);
            }
            /**
             * Validates and appends the "redirect_url" parameter to
             * the iFrame params object.
             *
             * @throws {TypeError} if redirectTo is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyRedirectTo",
            value: function _applyRedirectTo(params) {
              if ('redirectTo' in this._config) {
                var val = this._config.redirectTo;

                if (typeof val !== 'string') {
                  throw new TypeError('"redirectTo" must be a string');
                }

                params.append('redirect_url', val);
              }
            }
            /**
             * Validates and appends the "requester" parameter to the
             * iFrame params object.
             *
             * @throws {TypeError} if requestingEmail is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyRequestingEmail",
            value: function _applyRequestingEmail(params) {
              if ('requestingEmail' in this._config) {
                var val = this._config.requestingEmail;

                if (typeof val !== 'string') {
                  throw new TypeError('"requestingEmail" must be a string');
                }

                params.append('requester', val);
              }
            }
            /**
             * Validates and appends the "skip_domain_verification"
             * parameter to the iFrame params object.
             *
             * @throws {TypeError} if testMode is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyTestMode",
            value: function _applyTestMode(params) {
              var val = this._config.skipDomainVerification || this._config.testMode;

              if (typeof val !== 'boolean') {
                throw new TypeError('"testMode" must be a boolean');
              }

              params.append('skip_domain_verification', val ? 1 : 0);
            }
            /**
             * Validates and appends the "white_labeling_options"
             * parameter to the iFrame params object.
             *
             * @throws {TypeError} if whiteLabeling is invalid
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyWhiteLabeling",
            value: function _applyWhiteLabeling(params) {
              if ('whiteLabeling' in this._config) {
                var val = this._config.whiteLabeling;

                if (_typeof(val) !== 'object') {
                  throw new TypeError('"whiteLabeling" must be an object');
                }

                params.append('white_labeling_options', JSON.stringify(val));
              }
            }
            /**
             * Appends the "ux_version" parameter to the iFrame
             * params object.
             *
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyUxVersion",
            value: function _applyUxVersion(params) {
              params.append('ux_version', '2');
            }
            /**
             * Appends the "js_version" parameter to the iFrame params
             * object.
             *
             * @param {URLSearchParams} params
             * @private
             */

          }, {
            key: "_applyVersion",
            value: function _applyVersion(params) {
              params.append('js_version', "2.8.0");
            }
            /**
             * Validates and crates the iFrame params object.
             *
             * @param {URL} frameURL
             * @returns {URLSearchParams}
             * @private
             */

          }, {
            key: "_getFrameParams",
            value: function _getFrameParams(frameURL) {
              var params = new URLSearchParams(frameURL.search);

              this._applyClientId(params);

              this._applyDebug(params);

              this._applyFinalButtonText(params);

              this._applyHideHeader(params);

              this._applyLocale(params);

              this._applyParentURL(params);

              this._applyRedirectTo(params);

              this._applyRequestingEmail(params);

              this._applyTestMode(params);

              this._applyUxVersion(params);

              this._applyVersion(params);

              this._applyWhiteLabeling(params);

              return params;
            }
            /**
             * Calculates and sets the iFrame frame src.
             *
             * @param {string} url
             * @private
             */

          }, {
            key: "_updateFrameUrl",
            value: function _updateFrameUrl(url) {
              var frameURL = new URL(url);

              var frameParams = this._getFrameParams(frameURL);

              frameURL.search = frameParams.toString();
              this._iFrameURL = frameURL;
            }
            /**
             * Renders the HelloSign Embedded markup.
             *
             * We would like to have used HTML Content Templates or
             * Range.createContextualFragment() but we are concerned
             * about browser support.
             *
             * @returns {HTMLElement}
             * @private
             */

          }, {
            key: "_renderMarkup",
            value: function _renderMarkup() {
              var elem = document.createElement('div');

              if (this._config.container) {
                elem.innerHTML = (0, _commonTags.safeHtml)(_templateObject(), _settings["default"].classNames.BASE, _settings["default"].classNames.IFRAME, _settings["default"].iframe.NAME, this._iFrameURL.href);
              } else {
                elem.innerHTML = (0, _commonTags.safeHtml)(_templateObject2(), _settings["default"].classNames.BASE, _settings["default"].classNames.BASE_IN_MODAL, _settings["default"].classNames.MODAL_SCREEN, _settings["default"].classNames.MODAL_CONTENT) + (this._config.allowCancel ? (0, _commonTags.safeHtml)(_templateObject3(), _settings["default"].classNames.MODAL_CLOSE, _settings["default"].classNames.MODAL_CLOSE_BTN) : '') + (0, _commonTags.safeHtml)(_templateObject4(), _settings["default"].classNames.IFRAME, _settings["default"].iframe.NAME, this._iFrameURL.href);
              }

              return elem.firstChild;
            }
            /**
             * Renders the HelloSign Embedded markup into the DOM.
             *
             * @private
             */

          }, {
            key: "_appendMarkup",
            value: function _appendMarkup() {
              this._baseEl = this._renderMarkup(); // Listen for click events within the HelloSign
              // Embedded DOM markup. These will be delegated
              // depending on the source element.

              this._baseEl.addEventListener('click', this._onEmbeddedClick); // Obtain element references.


              this._iFrameEl = this._baseEl.getElementsByClassName(_settings["default"].classNames.IFRAME).item(0); // Insert HelloSign Embedded markup into the DOM.

              if (this._config.container) {
                this._config.container.appendChild(this._baseEl);
              } else {
                document.body.appendChild(this._baseEl);
              }
            }
            /**
             * Removes the HelloSign Embedded markup from the DOM.
             *
             *
             * @private
             */

          }, {
            key: "_clearMarkup",
            value: function _clearMarkup() {
              this._baseEl.parentElement.removeChild(this._baseEl);
            }
            /**
             * @typedef {Object} HelloSignMessage
             * @property {string} type
             * @property {Object} [payload]
             */

            /**
             * Posts a cross-origin window message to the HelloSign
             * Embedded iFrame content window.
             *
             * @param {HelloSignMessage} msg
             * @private
             */

          }, {
            key: "_sendMessage",
            value: function _sendMessage(msg) {
              _debug["default"].info('posting message', msg);

              var targetOrigin = this._iFrameURL.href;
              var targetWindow = this._iFrameEl.contentWindow;
              targetWindow.postMessage(msg, targetOrigin);
            }
            /**
             * Sends a cancel request message to the app.
             *
             * @private
             */

          }, {
            key: "_sendCancelRequestMessage",
            value: function _sendCancelRequestMessage() {
              _debug["default"].info('sending cancel request message');

              this._sendMessage({
                type: _settings["default"].messages.USER_CANCEL_REQUEST
              });
            }
            /**
             * Sends the configuration message to the app.
             *
             * @private
             */

          }, {
            key: "_sendConfigurationMessage",
            value: function _sendConfigurationMessage() {
              _debug["default"].info('sending app configuration message');

              this._sendMessage({
                type: _settings["default"].messages.APP_CONFIGURE,
                payload: {
                  allowCancel: this._config.allowCancel
                }
              });
            }
            /**
             * Sends the domain verification response.
             *
             * @param {string} token
             * @private
             */

          }, {
            key: "_sendDomainVerificationMessage",
            value: function _sendDomainVerificationMessage(token) {
              _debug["default"].info('sending domain verification message', token);

              this._sendMessage({
                type: _settings["default"].messages.APP_VERIFY_DOMAIN_RESPONSE,
                payload: {
                  token: token
                }
              });
            }
            /**
             * Sends the initialization error message.
             *
             * @private
             */

          }, {
            key: "_sendInitializationErrorMessage",
            value: function _sendInitializationErrorMessage() {
              _debug["default"].info('sending initialization error message');

              this._sendMessage({
                type: _settings["default"].messages.APP_ERROR,
                payload: {
                  message: 'App failed to initialize before timeout'
                }
              });
            }
            /**
             * Clears the initialization timeout timer.
             *
             * @private
             */

          }, {
            key: "_clearInitTimeout",
            value: function _clearInitTimeout() {
              if (this._initTimeout) {
                _debug["default"].info('clearing initialization timeout');

                clearTimeout(this._initTimeout);
                this._initTimeout = null;
              }
            }
            /**
             * Starts the initialization timeout timer.
             *
             * @private
             */

          }, {
            key: "_startInitTimeout",
            value: function _startInitTimeout() {
              _debug["default"].info('starting initialization timeout');

              this._clearInitTimeout();

              this._initTimeout = setTimeout(this._onInitTimeout, this._config.timeout);
            }
            /**
             * Starts the initialization timeout timer if the workflow
             * is embedded signing.
             *
             * @private
             */

          }, {
            key: "_maybeStartInitTimeout",
            value: function _maybeStartInitTimeout() {
              if (this._iFrameURL.href.includes('embeddedSign')) {
                // Start the initialization timeout because this is
                // embedded signing.
                this._startInitTimeout();
              }
            }
            /**
             * @event HelloSign#error
             * @type {Object}
             * @property {string} signatureId
             * @property {number} code
             */

            /**
             * Called when the app encountered an error.
             *
             * @emits HelloSign#error
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_appDidError",
            value: function _appDidError(payload) {
              _debug["default"].error('app encountered an error with code:', payload.code);

              this.emit(_settings["default"].events.ERROR, payload);
            }
            /**
             * @event HelloSign#ready
             * @type {Object}
             * @property {string} signatureId
             */

            /**
             * Called when the app was initialized.
             *
             * @emits HelloSign#ready
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_appDidInitialize",
            value: function _appDidInitialize(payload) {
              _debug["default"].info('app was initialized');

              this._isReady = true;

              this._sendConfigurationMessage();

              this._clearInitTimeout();

              window.addEventListener('beforeunload', this._onBeforeUnload);
              this.emit(_settings["default"].events.READY, payload);
            }
            /**
             * Called when the app requested domain verification.
             *
             * @param {Object} payload
             * @param {string} payload.token
             * @private
             */

          }, {
            key: "_appDidRequestDomainVerification",
            value: function _appDidRequestDomainVerification(_ref) {
              var token = _ref.token;

              _debug["default"].info('app requested domain verification', token);

              this._sendDomainVerificationMessage(token);
            }
            /**
             * @event HelloSign#message
             * @type {Object}
             * @property {string} type
             * @property {?Object} payload
             */

            /**
             * Called when HelloSign Embedded receives a cross-origin
             * window message.
             *
             * @emits HelloSign#message
             * @param {MessageEvent} evt
             * @private
             */

          }, {
            key: "_appDidSendMessage",
            value: function _appDidSendMessage(_ref2) {
              var data = _ref2.data,
                  origin = _ref2.origin;

              _debug["default"].info('received message', data, origin);

              this.emit(_settings["default"].events.MESSAGE, data);

              this._delegateMessage(data);
            }
            /**
             * @event HelloSign#cancel
             */

            /**
             * Called when the user canceled the request.
             *
             * @emits HelloSign#cancel
             * @private
             */

          }, {
            key: "_userDidCancelRequest",
            value: function _userDidCancelRequest() {
              _debug["default"].info('user canceled the signature request');

              this.emit(_settings["default"].events.CANCEL);
              this.close();
            }
            /**
             * @event HelloSign#createTemplate
             * @type {Object}
             * @property {string} title
             * @property {string} message
             * @property {string[]} signerRoles
             * @property {Object} signatureRequestInfo
             */

            /**
             * Called when the user created the template.
             *
             * @emits HelloSign#createTemplate
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_userDidCreateTemplate",
            value: function _userDidCreateTemplate(payload) {
              _debug["default"].info('user created the signature request template');

              this.emit(_settings["default"].events.CREATE_TEMPLATE, payload);
            }
            /**
             * @event HelloSign#decline
             * @type {Object}
             * @property {string} signatureId
             * @property {string} reason
             */

            /**
             * Called when the user declined the request.
             *
             * @emits HelloSign#decline
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_userDidDeclineRequest",
            value: function _userDidDeclineRequest(payload) {
              _debug["default"].info('user declined the signature request');

              this.emit(_settings["default"].events.DECLINE, payload);
            }
            /**
             * @event HelloSign#finish
             */

            /**
             * Called when the user finished the request.
             *
             * @emits HelloSign#finish
             * @private
             */

          }, {
            key: "_userDidFinishRequest",
            value: function _userDidFinishRequest() {
              _debug["default"].info('user finished the signature request');

              this.emit(_settings["default"].events.FINISH);
              this.close();
            }
            /**
             * @event HelloSign#reassign
             * @type {Object}
             * @property {string} signatureId
             * @property {string} name
             * @property {string} email
             * @property {string} reason
             */

            /**
             * Called when the user reassigned the request.
             *
             * @emits HelloSign#reassign
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_userDidReassignRequest",
            value: function _userDidReassignRequest(payload) {
              _debug["default"].info('user reassigned the signature request with reason:', payload.reason);

              this.emit(_settings["default"].events.REASSIGN, payload);
            }
            /**
             * @event HelloSign#send
             * @type {Object}
             * @property {string} signatureRequestId
             * @property {string} signatureId
             */

            /**
             * Called when the user sent the request.
             *
             * @emits HelloSign#send
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_userDidSendRequest",
            value: function _userDidSendRequest(payload) {
              _debug["default"].info('user sent the signature request');

              this._isSentOrSigned = true;
              window.removeEventListener('beforeunload', this._onBeforeUnload);
              this.emit(_settings["default"].events.SEND, payload);
            }
            /**
             * @event HelloSign#sign
             * @type {Object}
             * @property {string} signatureId
             */

            /**
             * Called when the user signed the request.
             *
             * @emits HelloSign#sign
             * @param {Object} payload
             * @private
             */

          }, {
            key: "_userDidSignRequest",
            value: function _userDidSignRequest(payload) {
              _debug["default"].info('user signed the signature request');

              this._isSentOrSigned = true;
              window.removeEventListener('beforeunload', this._onBeforeUnload);
              this.emit(_settings["default"].events.SIGN, payload);
            }
            /**
             * Called when the user clicks anything within the
             * HelloSign Embedded boundary.
             *
             * @param {Event} evt
             * @private
             */

          }, {
            key: "_onEmbeddedClick",
            value: function _onEmbeddedClick(evt) {
              var elem = evt.target; // Check if the element that was clicked is the close
              // button.

              if (elem.classList.contains(_settings["default"].classNames.MODAL_CLOSE_BTN)) {
                evt.preventDefault(); // If the app is ready but has not yet been sent or
                // signed, close via the app. Otherwise, we force
                // close without notifying the app. This is because
                // the close button can represent a "cancel" or a
                // "close" depdending on the state of the request,
                // but Embedded is not aware of this state. Therefore
                // we send the close request down to the app so that
                // the app can determine the proper close type.

                if (this._isReady && !this._isSentOrSigned) {
                  this._sendCancelRequestMessage();
                } else {
                  this.close();
                }
              }
            }
            /**
             * Called when the initialization timeout timer completes.
             * Sends an error message to the app and closes HelloSign
             * Embedded.
             *
             * @private
             */

          }, {
            key: "_onInitTimeout",
            value: function _onInitTimeout() {
              _debug["default"].error('app failed to initialize before timeout'); // Display error to the user instead of just closing the
              // signature request window.
              // eslint-disable-next-line no-alert


              alert('Something went wrong when preparing your signature request. Please try again.');

              this._sendInitializationErrorMessage();

              this._clearInitTimeout();

              this.close();
            }
            /**
             * Called when the user navigates away from the page in
             * some way. Although modern browsers will likely block
             * this message, the browser may still natively confirm
             * with the user if they want to leave or stay on the
             * page.
             *
             * @see https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
             * @param {BeforeUnloadEvent} evt
             * @private
             */

          }, {
            key: "_onBeforeUnload",
            value: function _onBeforeUnload(evt) {
              if (this._isReady) {
                /* eslint-disable-next-line no-restricted-globals, no-alert */
                if (!confirm('Are you sure you want to close this signature request? You will lose your changes.')) {
                  evt.preventDefault(); // Chrome requires returnValue to be set.

                  evt.returnValue = '';
                }
              }
            }
            /**
             * Called when a message is received by the window.
             * Validates the message origin and delegates to the
             * appropriate method based on the message type.
             *
             * @param {MessageEvent} evt
             * @private
             */

          }, {
            key: "_onMessage",
            value: function _onMessage(message) {
              var strippedOrigin = message.origin.replace(/\/$/, '');

              if (strippedOrigin === this._iFrameURL.origin) {
                if (_typeof(message.data) === 'object') {
                  this._appDidSendMessage(message);
                }
              }
            }
            /**
             * Called when a message is received by the window.
             * Validates the message origin and delegates to the
             * appropriate method based on the message type.
             *
             * @param {HelloSignMessage} msg
             * @private
             */

          }, {
            key: "_delegateMessage",
            value: function _delegateMessage(_ref3) {
              var type = _ref3.type,
                  payload = _ref3.payload;

              switch (type) {
                case _settings["default"].messages.APP_ERROR:
                  this._appDidError(payload);

                  break;

                case _settings["default"].messages.APP_INITIALIZE:
                  this._appDidInitialize(payload);

                  break;

                case _settings["default"].messages.APP_VERIFY_DOMAIN_REQUEST:
                  this._appDidRequestDomainVerification(payload);

                  break;

                case _settings["default"].messages.USER_CANCEL_REQUEST:
                  this._userDidCancelRequest();

                  break;

                case _settings["default"].messages.USER_CREATE_TEMPLATE:
                  this._userDidCreateTemplate(payload);

                  break;

                case _settings["default"].messages.USER_DECLINE_REQUEST:
                  this._userDidDeclineRequest(payload);

                  break;

                case _settings["default"].messages.USER_FINISH_REQUEST:
                  this._userDidFinishRequest();

                  break;

                case _settings["default"].messages.USER_REASSIGN_REQUEST:
                  this._userDidReassignRequest(payload);

                  break;

                case _settings["default"].messages.USER_SEND_REQUEST:
                  this._userDidSendRequest(payload);

                  break;

                case _settings["default"].messages.USER_SIGN_REQUEST:
                  this._userDidSignRequest(payload);

                  break;

                default:
                  // Unhandled message.
                  _debug["default"].warn('unhandled cross-origin window message', type);

              }
            }
            /**
             * @event HelloSign#open
             * @type {Object}
             * @property {string} url
             * @property {string} iFrameUrl
             */

            /**
             * @typedef {Object} HelloSignOptions
             * @property {boolean} [allowCancel=true]
             * @property {string} [clientId]
             * @property {HTMLElement} [container]
             * @property {boolean} [debug=false]
             * @property {boolean} [hideHeader=false]
             * @property {string} [locale="en_US"]
             * @property {string} [redirectTo]
             * @property {string} [requestingEmail]
             * @property {boolean} [skipDomainVerification=false]
             * @property {boolean} [testMode=false]
             * @property {number} [timeout=30000]
             * @property {Object} [whiteLabeling]
             */

            /**
             * Opens the url in HelloSign Embedded.
             *
             * @emits HelloSign#open
             * @param {string} url
             * @param {HelloSignOptions} [opts={}]
             * @public
             */

          }, {
            key: "open",
            value: function open(url) {
              var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

              _debug["default"].info('open()', url, opts); // Close if embedded is already open.


              if (this._isOpen) {
                this.close();
              }

              this._config = _objectSpread({}, _defaults["default"], this._baseConfig, opts); // Check if container is valid.

              if (this._config.container) {
                if (!(this._config.container instanceof HTMLElement)) {
                  throw new TypeError('"container" must be an element');
                }
              }

              this._updateFrameUrl(url);

              this._appendMarkup();

              this._maybeStartInitTimeout();

              this._isOpen = true;
              window.addEventListener('message', this._onMessage);
              this.emit(_settings["default"].events.OPEN, {
                url: this._iFrameURL.href
              });
            }
            /**
             * @event HelloSign#close
             */

            /**
             * Closes the HelloSign Embeded window.
             *
             * @emits HelloSign#close
             * @public
             */

          }, {
            key: "close",
            value: function close() {
              _debug["default"].info('close()'); // It's already closed!


              if (!this._isOpen) {
                return;
              }

              this._clearInitTimeout();

              this._clearMarkup();

              this._baseEl.removeEventListener('click', this._onEmbeddedClick);

              this._config = null;
              this._baseEl = null;
              this._iFrameEl = null;
              this._iFrameURL = null;
              this._isOpen = false;
              this._isReady = false;
              this._isSentOrSigned = false;
              window.removeEventListener('message', this._onMessage);
              window.removeEventListener('beforeunload', this._onBeforeUnload);
              this.emit(_settings["default"].events.CLOSE);
            }
            /**
             * Overrides tiny-emitter's "emit" method.
             *
             * @see https://www.npmjs.com/package/tiny-emitter
             * @param {string} name
             * @param {any} [data]
             * @override
             */

          }, {
            key: "emit",
            value: function emit() {
              var _get2;

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              _debug["default"].info.apply(_debug["default"], ['emit()'].concat(args));

              (_get2 = _get(_getPrototypeOf(HelloSign.prototype), "emit", this)).call.apply(_get2, [this].concat(args));
            }
            /**
             * @returns {?HTMLElement}
             * @public
             */

          }, {
            key: "element",
            get: function get() {
              return this._baseEl;
            }
            /**
             * @returns {?HTMLElement}
             * @public
             */

          }, {
            key: "iFrame",
            get: function get() {
              return this._iFrameEl;
            }
            /**
             * @returns {boolean}
             * @public
             */

          }, {
            key: "isOpen",
            get: function get() {
              return this._isOpen;
            }
            /**
             * @returns {boolean}
             * @public
             */

          }, {
            key: "isReady",
            get: function get() {
              return this._isReady;
            }
          }]);

          return HelloSign;
        }(_tinyEmitter["default"]);

        _defineProperty(HelloSign, "classNames", _settings["default"].classNames);

        _defineProperty(HelloSign, "events", _settings["default"].events);

        _defineProperty(HelloSign, "locales", _settings["default"].locales);

        _defineProperty(HelloSign, "messages", _settings["default"].messages);

        _defineProperty(HelloSign, "version", "2.8.0");

        var _default = HelloSign;
        exports["default"] = _default;
        /***/
      },

      /***/
      "./src/sass/embedded.scss":
      /*!********************************!*\
        !*** ./src/sass/embedded.scss ***!
        \********************************/

      /*! no static exports found */

      /***/
      function srcSassEmbeddedScss(module, exports, __webpack_require__) {
        var content = __webpack_require__(
        /*! !../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/lib/loader.js!./embedded.scss */
        "./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/lib/loader.js!./src/sass/embedded.scss");

        if (typeof content === 'string') content = [[module.i, content, '']];
        var transform;
        var insertInto;
        var options = {
          "hmr": true
        };
        options.transform = transform;
        options.insertInto = undefined;

        var update = __webpack_require__(
        /*! ../../node_modules/style-loader/lib/addStyles.js */
        "./node_modules/style-loader/lib/addStyles.js")(content, options);

        if (content.locals) module.exports = content.locals;

        if (false) {}
        /***/

      },

      /***/
      "./src/settings.js":
      /*!*************************!*\
        !*** ./src/settings.js ***!
        \*************************/

      /*! no static exports found */

      /***/
      function srcSettingsJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;
        /**
         * HelloSign Embedded class names.
         *
         * @enum {string}
         * @readonly
         */

        var classNames = {
          BASE: 'x-hellosign-embedded',
          BASE_IN_MODAL: 'x-hellosign-embedded--in-modal',
          IFRAME: 'x-hellosign-embedded__iframe',
          MODAL_CLOSE: 'x-hellosign-embedded__modal-close',
          MODAL_CLOSE_BTN: 'x-hellosign-embedded__modal-close-button',
          MODAL_CONTENT: 'x-hellosign-embedded__modal-content',
          MODAL_SCREEN: 'x-hellosign-embedded__modal-screen'
        };
        /**
         * HelloSign Embedded events.
         *
         * @enum {string}
         * @readonly
         */

        var events = {
          ERROR: 'error',
          SEND: 'send',
          CANCEL: 'cancel',
          CLOSE: 'close',
          CREATE_TEMPLATE: 'createTemplate',
          DECLINE: 'decline',
          FINISH: 'finish',
          MESSAGE: 'message',
          OPEN: 'open',
          READY: 'ready',
          REASSIGN: 'reassign',
          SIGN: 'sign'
        };
        /**
         * HelloSign Embedded iFrame properties.
         *
         * @enum {string}
         * @readonly
         */

        var iframe = {
          NAME: 'x-hellosign-embedded'
        };
        /**
         * HelloSign Embedded supported locales.
         *
         * @enum {string}
         * @readonly
         */

        var locales = {
          CS_CZ: 'cs-CZ',
          // Czech (Czech Republic)
          DA_DK: 'da-DK',
          // Danish (Denmark)
          DE_DE: 'de-DE',
          // German (Germany)
          EN_GB: 'en-GB',
          // English (United Kingdom)
          EN_US: 'en-US',
          // English (United States)
          ES_LA: 'es-LA',
          // Spanish (Latin America)
          ES_ES: 'es-ES',
          // Spanish (Spain)
          ES_MX: 'es-MX',
          // Spanish (Mexico)
          FR_FR: 'fr-FR',
          // French (France)
          ID_ID: 'id-ID',
          // Indonesian (Indonesia)
          IT_IT: 'it-IT',
          // Italian (Italy)
          JA_JP: 'ja-JP',
          // Japanese (Japan)
          KO_KR: 'ko-KR',
          // Korean (Korea)
          MS_MY: 'ms-MY',
          // Malaysian (Malaysia)
          NB_NO: 'nb-NO',
          // Norwegian (Norway)
          NL_NL: 'nl-NL',
          // Dutch (Netherlands)
          PL_PL: 'pl-PL',
          // Polish (Poland)
          PT_BR: 'pt-BR',
          // Portuguese (Brazil)
          RU_RU: 'ru-RU',
          // Russian (Russia)
          SV_SE: 'sv-SE',
          // Swedish (Sweden)
          TH_TH: 'th-TH',
          // Thai (Thailand)
          UK_UA: 'uk-UA',
          // Ukrainian (Ukraine)
          ZH_CN: 'zh-CN',
          // Chinese (Simplified) (China)
          ZH_TW: 'zh-TW' // Chinese (Traditional) (China)

        };
        /**
         * HelloSign Embedded cross-origin window messages.
         *
         * @enum {string}
         * @readonly
         */

        var messages = {
          APP_CONFIGURE: 'hellosign:configure',
          APP_ERROR: 'hellosign:error',
          APP_INITIALIZE: 'hellosign:initialize',
          APP_VERIFY_DOMAIN_REQUEST: 'hellosign:verifyDomainRequest',
          APP_VERIFY_DOMAIN_RESPONSE: 'hellosign:verifyDomainResponse',
          USER_CANCEL_REQUEST: 'hellosign:userCancelRequest',
          USER_CREATE_TEMPLATE: 'hellosign:userCreateTemplate',
          USER_DECLINE_REQUEST: 'hellosign:userDeclineRequest',
          USER_FINISH_REQUEST: 'hellosign:userFinishRequest',
          USER_REASSIGN_REQUEST: 'hellosign:userReassignRequest',
          USER_SEND_REQUEST: 'hellosign:userSendRequest',
          USER_SIGN_REQUEST: 'hellosign:userSignRequest'
        };
        var _default = {
          classNames: classNames,
          events: events,
          iframe: iframe,
          locales: locales,
          messages: messages
        };
        exports["default"] = _default;
        /***/
      },

      /***/
      "./src/utils/debug.js":
      /*!****************************!*\
        !*** ./src/utils/debug.js ***!
        \****************************/

      /*! no static exports found */

      /***/
      function srcUtilsDebugJs(module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true
        });
        exports["default"] = void 0;

        var _debug = _interopRequireDefault(__webpack_require__(
        /*! debug */
        "./node_modules/debug/src/browser.js"));

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }
        /**
         * To enable debug messages, enter the following into your
         * developer tools console:
         *
         *   localStorage.debug = 'hellosign-embedded:*';
         *
         * This will surface all debug messages under the
         * "hellosign:" namespace.
         */


        var info = (0, _debug["default"])("".concat("hellosign-embedded", ":info"));
        var warn = (0, _debug["default"])("".concat("hellosign-embedded", ":warn"));
        var error = (0, _debug["default"])("".concat("hellosign-embedded", ":error"));
        info.log = console.log.bind(console); // eslint-disable-line no-console

        warn.log = console.warn.bind(console); // eslint-disable-line no-console

        var _default = {
          info: info,
          warn: warn,
          error: error
        };
        exports["default"] = _default;
        /***/
      },

      /***/
      0:
      /*!************************************************************************************************!*\
        !*** multi url-polyfill url-search-params-polyfill ./src/sass/embedded.scss ./src/embedded.js ***!
        \************************************************************************************************/

      /*! no static exports found */

      /***/
      function _(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! url-polyfill */
        "./node_modules/url-polyfill/url-polyfill.js");

        __webpack_require__(
        /*! url-search-params-polyfill */
        "./node_modules/url-search-params-polyfill/index.js");

        __webpack_require__(
        /*! ./src/sass/embedded.scss */
        "./src/sass/embedded.scss");

        module.exports = __webpack_require__(
        /*! ./src/embedded.js */
        "./src/embedded.js");
        /***/
      }
      /******/

    })["default"]
  );
});